import React from 'react';

export function Search() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.7">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 11C4 7.13401 7.13401 4 11 4C14.866 4 18 7.13401 18 11C18 12.886 17.2542 14.5977 16.0413 15.8564C16.0071 15.8827 15.9742 15.9116 15.9429 15.9429C15.9116 15.9742 15.8828 16.0071 15.8565 16.0413C14.5978 17.2541 12.886 18 11 18C7.13401 18 4 14.866 4 11ZM16.6177 18.0319C15.078 19.2635 13.125 20 11 20C6.02944 20 2 15.9706 2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11C20 13.125 19.2635 15.078 18.0319 16.6177L21.7071 20.2929C22.0977 20.6834 22.0977 21.3166 21.7071 21.7071C21.3166 22.0976 20.6834 22.0976 20.2929 21.7071L16.6177 18.0319Z"
          fill="#2D5179"
        />
      </g>
    </svg>
  );
}

export function Bell() {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="#fff"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.25 6C14.25 4.80653 13.7496 3.66193 12.8588 2.81802C11.968 1.97411 10.7598 1.5 9.5 1.5C8.24022 1.5 7.03204 1.97411 6.14124 2.81802C5.25045 3.66193 4.75 4.80653 4.75 6C4.75 11.25 2.375 12.75 2.375 12.75H16.625C16.625 12.75 14.25 11.25 14.25 6Z"
        stroke="#2D5179"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8695 15.75C10.7304 15.9773 10.5306 16.166 10.2902 16.2971C10.0499 16.4283 9.77734 16.4973 9.49995 16.4973C9.22257 16.4973 8.95005 16.4283 8.70969 16.2971C8.46933 16.166 8.26955 15.9773 8.13037 15.75"
        stroke="#2D5179"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function Slider() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_503_2944)">
        <path
          d="M2.6665 13.9997V9.33301"
          stroke="#174A84"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.6665 6.66667V2"
          stroke="#174A84"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 14V8"
          stroke="#174A84"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 5.33333V2"
          stroke="#174A84"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.3335 14.0003V10.667"
          stroke="#174A84"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.3335 8V2"
          stroke="#174A84"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.666504 9.33301H4.6665"
          stroke="#174A84"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 5.33301H10"
          stroke="#174A84"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.3335 10.667H15.3335"
          stroke="#174A84"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_503_2944">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
export function MarsLogo() {
  return (
    <svg
      width="47"
      height="14"
      viewBox="0 0 47 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.328 1.236V13H10.781V4.228L6.871 13H5.783L1.856 4.211V13H0.309V1.236H1.975L6.327 10.96L10.679 1.236H12.328ZM22.0406 10.586H17.0936L16.2436 13H14.2206L18.4536 1.168H20.6976L24.9306 13H22.8906L22.0406 10.586ZM21.4966 9.005L19.5756 3.514L17.6376 9.005H21.4966ZM32.7891 13L30.1711 8.376H29.0491V13H26.6691V1.134H31.1231C32.0411 1.134 32.8231 1.29833 33.4691 1.627C34.1151 1.94433 34.5968 2.38067 34.9141 2.936C35.2428 3.48 35.4071 4.092 35.4071 4.772C35.4071 5.554 35.1804 6.26233 34.7271 6.897C34.2738 7.52033 33.5994 7.951 32.7041 8.189L35.5431 13H32.7891ZM29.0491 6.591H31.0381C31.6841 6.591 32.1658 6.438 32.4831 6.132C32.8004 5.81467 32.9591 5.37833 32.9591 4.823C32.9591 4.279 32.8004 3.85967 32.4831 3.565C32.1658 3.259 31.6841 3.106 31.0381 3.106H29.0491V6.591ZM41.7587 13.119C40.8861 13.119 40.1041 12.9773 39.4127 12.694C38.7214 12.4107 38.1661 11.9913 37.7467 11.436C37.3387 10.8807 37.1234 10.212 37.1007 9.43H40.1947C40.2401 9.872 40.3931 10.212 40.6537 10.45C40.9144 10.6767 41.2544 10.79 41.6737 10.79C42.1044 10.79 42.4444 10.6937 42.6937 10.501C42.9431 10.297 43.0677 10.0193 43.0677 9.668C43.0677 9.37333 42.9657 9.12967 42.7617 8.937C42.5691 8.74433 42.3254 8.58567 42.0307 8.461C41.7474 8.33633 41.3394 8.19467 40.8067 8.036C40.0361 7.798 39.4071 7.56 38.9197 7.322C38.4324 7.084 38.0131 6.73267 37.6617 6.268C37.3104 5.80333 37.1347 5.197 37.1347 4.449C37.1347 3.33833 37.5371 2.47133 38.3417 1.848C39.1464 1.21333 40.1947 0.896 41.4867 0.896C42.8014 0.896 43.8611 1.21333 44.6657 1.848C45.4704 2.47133 45.9011 3.344 45.9577 4.466H42.8127C42.7901 4.08067 42.6484 3.78033 42.3877 3.565C42.1271 3.33833 41.7927 3.225 41.3847 3.225C41.0334 3.225 40.7501 3.32133 40.5347 3.514C40.3194 3.69533 40.2117 3.96167 40.2117 4.313C40.2117 4.69833 40.3931 4.99867 40.7557 5.214C41.1184 5.42933 41.6851 5.66167 42.4557 5.911C43.2264 6.17167 43.8497 6.421 44.3257 6.659C44.8131 6.897 45.2324 7.24267 45.5837 7.696C45.9351 8.14933 46.1107 8.733 46.1107 9.447C46.1107 10.127 45.9351 10.7447 45.5837 11.3C45.2437 11.8553 44.7451 12.2973 44.0877 12.626C43.4304 12.9547 42.6541 13.119 41.7587 13.119Z"
        fill="white"
      />
    </svg>
  );
}
export function Confirmation() {
  return (
    // <svg
    //   width="56"
    //   height="56"
    //   viewBox="0 0 56 56"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M5.0165 33.1037C2.24596 30.36 2.22425 25.8898 4.968 23.1192L22.896 5.01622C25.6397 2.24568 30.1099 2.22397 32.8805 4.96772L50.9835 22.8957C53.754 25.6394 53.7758 30.1097 51.032 32.8802L33.104 50.9832C30.3603 53.7538 25.8901 53.7755 23.1195 51.0317L5.0165 33.1037Z"
    //     fill="#F7CE46"
    //   />
    //   <path
    //     d="M30.7027 15.5312L30.0469 32.4013H25.2923L24.6365 15.5312H30.7027ZM27.7516 41.4175C26.7678 41.4175 25.959 41.1123 25.3251 40.5018C24.713 39.8679 24.4069 39.093 24.4069 38.1773C24.4069 37.2381 24.713 36.4516 25.3251 35.8176C25.959 35.1837 26.7678 34.8667 27.7516 34.8667C28.7134 34.8667 29.5004 35.1837 30.1125 35.8176C30.7464 36.4516 31.0634 37.2381 31.0634 38.1773C31.0634 39.093 30.7464 39.8679 30.1125 40.5018C29.5004 41.1123 28.7134 41.4175 27.7516 41.4175Z"
    //     fill="white"
    //   />
    // </svg>
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.275 13.2L26.6838 27.2767H22.3981L21.807 13.2H27.275ZM24.6149 34.8C23.7282 34.8 22.9991 34.5453 22.4277 34.0359C21.876 33.5069 21.6001 32.8604 21.6001 32.0963C21.6001 31.3126 21.876 30.6563 22.4277 30.1273C22.9991 29.5983 23.7282 29.3338 24.6149 29.3338C25.4819 29.3338 26.1912 29.5983 26.743 30.1273C27.3144 30.6563 27.6001 31.3126 27.6001 32.0963C27.6001 32.8604 27.3144 33.5069 26.743 34.0359C26.1912 34.5453 25.4819 34.8 24.6149 34.8Z"
        fill="#F1BC0C"
      />
      <circle cx="24" cy="24" r="22.5" stroke="#F1BC0C" strokeWidth="3" />
    </svg>
  );
}
export function Plus() {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 5V19"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 12H19.5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function GridExport() {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5348 1.292L13.3097 0H3.6622C2.96617 0 2.69715 0.4902 2.69715 0.87305V4.32155H4.05023V1.57035C4.05023 1.42405 4.18023 1.30055 4.33024 1.30055H11.2336C11.3856 1.30055 11.4616 1.3262 11.4616 1.44495V6.02395H16.3749C16.5679 6.02395 16.6429 6.11895 16.6429 6.25765V17.4391C16.6429 17.6728 16.5429 17.708 16.3929 17.708H4.33024C4.25586 17.7063 4.18508 17.6772 4.13284 17.6269C4.0806 17.5765 4.05098 17.5089 4.05023 17.4382V16.416H2.70615V18.0263C2.68815 18.5963 3.00817 19 3.6622 19H17.0609C17.761 19 18 18.5184 18 18.0795V4.92765L17.65 4.56665L14.5338 1.29295L14.5348 1.292ZM12.8367 1.444L13.2237 1.8563L15.8199 4.56665L15.9629 4.731H13.3097C13.1097 4.731 12.9827 4.69965 12.9297 4.636C12.8767 4.57425 12.8457 4.4745 12.8367 4.33865V1.444ZM11.7467 10.1336H16.3239V11.401H11.7457V10.1336H11.7467ZM11.7467 7.60095H16.3239V8.8673H11.7457V7.6L11.7467 7.60095ZM11.7467 12.6673H16.3239V13.9346H11.7457V12.6673H11.7467ZM0 5.3447V15.4783H10.4656V5.3447H0ZM5.23329 11.2385L4.59326 12.1676H5.23329V13.3H2.01611L4.35024 9.9655L2.28213 6.9673H4.01022L5.23429 8.7115L6.45736 6.9673H8.18445L6.11234 9.9655L8.44947 13.3H6.65637L5.23329 11.2385Z"
        fill="#2F80ED"
      />
    </svg>
  );
}
export function SuccessIcon() {
  return (
    <svg
      width="61"
      height="61"
      viewBox="0 0 61 61"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="61" height="61" fill="none" />
    </svg>
  );
}
export function NoListIcon() {
  return (
    <svg
      width="55"
      height="60"
      viewBox="0 0 55 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M50.9982 36.7416L49.5263 42.3269C49.3636 42.9787 49.7595 43.6385 50.4108 43.8012L50.9982 36.7416ZM50.9982 36.7416H51.13V36.2416L50.6465 36.1141L50.6129 36.2416H11.361L5.6718 56.9705H5.53457V57.4705L6.01674 57.6029L6.05307 57.4705H43.7225C44.2011 57.4621 44.6644 57.2994 45.043 57.0062C45.421 56.7124 45.6943 56.3043 45.8217 55.8431L47.6145 49.0026C47.784 48.3513 48.449 47.9607 49.1003 48.1297C49.7521 48.2992 50.1428 48.9642 49.9732 49.616L50.9982 36.7416ZM52.6615 34.3843H52.7458L52.8057 34.3636C52.9879 34.3847 53.1554 34.479 53.2679 34.6268L53.2682 34.6272C53.3957 34.7944 53.4385 35.0117 53.3836 35.2152L53.4067 35.2214L53.3827 35.2183L51.4014 42.7901L51.4014 42.7901L51.4 42.7956C51.3042 43.1793 50.9156 43.4123 50.5324 43.3162L50.5321 43.3161C50.1497 43.2206 49.9167 42.834 50.0107 42.4508C50.011 42.4499 50.0112 42.4489 50.0114 42.448L51.6135 36.369L51.7788 35.7416H51.13H11.361H10.9798L10.8789 36.1092L5.05241 57.3382L4.87886 57.9705H5.53457H43.7225V57.9706L43.7313 57.9705C44.3175 57.9601 44.8852 57.7609 45.3492 57.4014L45.3498 57.4009C45.8128 57.0411 46.1475 56.5414 46.3036 55.9762L46.3037 55.9762L46.3054 55.9699L48.0982 49.1294L48.0984 49.1286C48.1984 48.7443 48.5906 48.514 48.9747 48.6136C49.3592 48.7138 49.5893 49.1057 49.4893 49.4901L49.4888 49.492L47.7435 56.3087L47.7432 56.3096C47.5242 57.1722 47.0239 57.9375 46.3213 58.4848C45.6187 59.0315 44.7541 59.3287 43.8639 59.3292L3.97654 59.3292L3.9716 59.3292C3.76856 59.3312 3.57712 59.2396 3.45188 59.0822C3.37029 58.9334 3.31706 58.771 3.29522 58.6032L1.05539 22.6958C1.05538 22.6957 1.05537 22.6956 1.05537 22.6955C1.01388 22.0155 1.25537 21.3483 1.72204 20.8516C2.19985 20.3463 2.86082 20.0545 3.55642 20.042H12.2204C13.2188 20.0905 14.1474 20.5712 14.7628 21.3592L14.8061 21.4147L17.2619 24.5887L17.412 24.7827H17.6573H44.0756C44.2585 24.7827 44.4334 24.8563 44.5608 24.9863C44.6888 25.1171 44.7588 25.2934 44.7551 25.4759L44.755 25.4759V25.4858V30.2034C44.755 30.5785 44.4508 30.8828 44.0756 30.8828C43.7005 30.8828 43.3962 30.5785 43.3962 30.2034V26.6652V26.1652H42.8962L17.2098 26.1652L17.2069 26.1652C17.0032 26.1664 16.8103 26.0724 16.6854 25.9111L16.6848 25.9104L13.8087 22.2091C13.4348 21.7167 12.8527 21.4267 12.2349 21.4239H12.2327H3.55902C3.24616 21.4169 2.94482 21.5391 2.7251 21.7616L2.72434 21.7624C2.49916 21.9914 2.3888 22.3062 2.41691 22.6226L4.11499 51.6511L5.09566 51.7566L9.81321 34.892L9.81323 34.892L9.81453 34.8872C9.89387 34.5922 10.1601 34.3867 10.4654 34.3843H52.6615Z"
        fill="white"
        stroke="#2D5179"
      />
      <path
        d="M27.09 51.0567L27.0901 51.0567L27.0929 51.0538C27.841 50.2987 28.8593 49.874 29.9221 49.874C30.9849 49.874 32.0032 50.2987 32.7512 51.0538L32.7512 51.0538L32.7541 51.0567C32.8831 51.1847 32.9555 51.3588 32.9555 51.5396C32.9555 51.7205 32.883 51.8943 32.7546 52.0215L32.748 52.028L32.7417 52.0347C32.6225 52.1618 32.4555 52.2342 32.2809 52.2342C32.1062 52.2342 31.9392 52.1618 31.82 52.0347L31.8143 52.0286L31.8084 52.0227C31.3079 51.5235 30.6298 51.2423 29.9221 51.2423C29.2144 51.2423 28.5363 51.5235 28.0358 52.0227L28.0299 52.0286L28.0241 52.0347C27.905 52.1618 27.738 52.2342 27.5633 52.2342C27.3887 52.2342 27.2217 52.1618 27.1025 52.0347L27.0962 52.028L27.0896 52.0215C26.9612 51.8943 26.8887 51.7205 26.8887 51.5396C26.8887 51.3588 26.9611 51.1847 27.09 51.0567Z"
        fill="white"
        stroke="#2D5179"
      />
      <path
        d="M20.488 43.3198C19.8367 43.3198 19.3086 43.8479 19.3086 44.4992C19.3086 45.1505 19.8367 45.6786 20.488 45.6786H22.8468C23.498 45.6786 24.0261 45.1505 24.0261 44.4992C24.0261 43.8479 23.498 43.3198 22.8468 43.3198H20.488Z"
        fill="#2D5179"
      />
      <path
        d="M36.9987 43.3198C36.3474 43.3198 35.8193 43.8479 35.8193 44.4992C35.8193 45.1505 36.3474 45.6786 36.9987 45.6786H39.3575C40.0088 45.6786 40.5369 45.1505 40.5369 44.4992C40.5369 43.8479 40.0088 43.3198 39.3575 43.3198H36.9987Z"
        fill="white"
      />
      <path
        d="M26.3852 20.4394C26.292 20.8953 26.4547 21.3655 26.8096 21.6662C27.0181 21.831 27.2756 21.922 27.5409 21.9252C27.712 21.961 27.8889 21.961 28.0601 21.9252L34.3813 18.7409C36.3663 19.3611 38.4349 19.6717 40.5141 19.6612C48.4398 19.6612 54.6668 15.5096 54.6668 10.2261C54.6668 5.86235 50.4915 2.20625 44.2645 1.0743V1.07378C43.6132 0.956889 42.9903 1.38969 42.8729 2.04098C42.756 2.69227 43.1888 3.31567 43.8401 3.43253C48.841 4.16385 52.3317 6.97069 52.3317 10.0845C52.3317 13.9291 46.9303 17.1609 40.5378 17.1609C38.5497 17.1677 36.5732 16.8492 34.6883 16.2174C34.4035 16.0879 34.0765 16.0879 33.7917 16.2174L29.3337 18.5762L30.3478 14.4483C30.4447 14.0734 30.3473 13.6748 30.0888 13.3868C29.2442 12.4923 28.7646 11.3145 28.744 10.0845C28.744 6.92392 32.4239 4.04594 37.4715 3.22037C38.1202 3.11191 38.5614 2.50221 38.4624 1.85255C38.3534 1.20389 37.7443 0.762146 37.0941 0.861646C30.7958 1.8994 26.3853 5.5792 26.3853 10.0609C26.4038 11.6299 26.9429 13.1483 27.9185 14.3772L26.3852 20.4394Z"
        fill="#2D5179"
      />
      <path
        d="M37.9429 9.1417L38.8627 10.0852L37.9429 11.005C37.4748 11.4747 37.4748 12.2339 37.9429 12.7036C38.4062 13.1406 39.1307 13.1406 39.594 12.7036L40.5375 11.7601L41.481 12.7036C41.9443 13.1406 42.6688 13.1406 43.1322 12.7036C43.6002 12.234 43.6002 11.4747 43.1322 11.005L42.2123 10.0852L43.1322 9.1417C43.3554 8.92004 43.4812 8.61887 43.4812 8.30402C43.4812 7.9897 43.3554 7.68853 43.1322 7.46687C42.9184 7.23889 42.6193 7.10938 42.3066 7.10938C41.9938 7.10938 41.6948 7.2389 41.481 7.46687L40.5375 8.41038L39.594 7.46687C39.3802 7.23889 39.0812 7.10938 38.7684 7.10938C38.4557 7.10938 38.1566 7.2389 37.9429 7.46687C37.7196 7.68853 37.5938 7.9897 37.5938 8.30402C37.5938 8.61887 37.7196 8.92004 37.9429 9.1417Z"
        fill="#2D5179"
      />
    </svg>
  );
}
export function AngleLeft() {
  return (
    <svg
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 13L1 7L7 1"
        stroke="#2f80ed"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function Calendar() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6667 2.66699H3.33333C2.59695 2.66699 2 3.26395 2 4.00033V13.3337C2 14.07 2.59695 14.667 3.33333 14.667H12.6667C13.403 14.667 14 14.07 14 13.3337V4.00033C14 3.26395 13.403 2.66699 12.6667 2.66699Z"
        className="icon-stroke"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6665 1.33301V3.99967"
        className="icon-stroke"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.3335 1.33301V3.99967"
        className="icon-stroke"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 6.66699H14"
        className="icon-stroke"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function ChevronDown() {
  return (
    <svg
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1L7 7L13 1"
        className="icon-stroke"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function Trash() {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.8" clipPath="url(#clip0_1833_12327)">
        <path
          d="M2.125 4.75H3.54167H14.875"
          className="icon-stroke"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.66602 4.74935V3.33268C5.66602 2.95696 5.81527 2.59662 6.08095 2.33095C6.34662 2.06527 6.70696 1.91602 7.08268 1.91602H9.91602C10.2917 1.91602 10.6521 2.06527 10.9178 2.33095C11.1834 2.59662 11.3327 2.95696 11.3327 3.33268V4.74935M13.4577 4.74935V14.666C13.4577 15.0417 13.3084 15.4021 13.0428 15.6678C12.7771 15.9334 12.4167 16.0827 12.041 16.0827H4.95768C4.58196 16.0827 4.22162 15.9334 3.95595 15.6678C3.69027 15.4021 3.54102 15.0417 3.54102 14.666V4.74935H13.4577Z"
          className="icon-stroke"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1833_12327">
          <rect
            width="17"
            height="17"
            className="icon-fill"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export function Image() {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.8">
        <path
          d="M13.4583 2.625H3.54167C2.75926 2.625 2.125 3.25926 2.125 4.04167V13.9583C2.125 14.7407 2.75926 15.375 3.54167 15.375H13.4583C14.2407 15.375 14.875 14.7407 14.875 13.9583V4.04167C14.875 3.25926 14.2407 2.625 13.4583 2.625Z"
          className="icon-stroke"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.02148 7.58398C6.60829 7.58398 7.08398 7.10829 7.08398 6.52148C7.08398 5.93468 6.60829 5.45898 6.02148 5.45898C5.43468 5.45898 4.95898 5.93468 4.95898 6.52148C4.95898 7.10829 5.43468 7.58398 6.02148 7.58398Z"
          className="icon-stroke"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.8743 11.1257L11.3327 7.58398L3.54102 15.3757"
          className="icon-stroke"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}
export function Attach() {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.6868 8.3265L9.17721 14.8361C8.37973 15.6336 7.29813 16.0816 6.17033 16.0816C5.04254 16.0816 3.96093 15.6336 3.16346 14.8361C2.36598 14.0386 1.91797 12.957 1.91797 11.8292C1.91797 10.7014 2.36598 9.6198 3.16346 8.82233L9.67304 2.31275C10.2047 1.7811 10.9258 1.48242 11.6776 1.48242C12.4295 1.48242 13.1506 1.7811 13.6822 2.31275C14.2139 2.8444 14.5125 3.56547 14.5125 4.31733C14.5125 5.06919 14.2139 5.79027 13.6822 6.32191L7.16554 12.8315C6.89972 13.0973 6.53918 13.2467 6.16325 13.2467C5.78732 13.2467 5.42678 13.0973 5.16096 12.8315C4.89513 12.5657 4.74579 12.2051 4.74579 11.8292C4.74579 11.4533 4.89513 11.0927 5.16096 10.8269L11.1747 4.82025"
        className="icon-stroke"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function Square() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9583 1.625H3.04167C2.25926 1.625 1.625 2.25926 1.625 3.04167V12.9583C1.625 13.7407 2.25926 14.375 3.04167 14.375H12.9583C13.7407 14.375 14.375 13.7407 14.375 12.9583V3.04167C14.375 2.25926 13.7407 1.625 12.9583 1.625Z"
        className="icon-stroke"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function Star() {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.00033 1.91602L11.1891 6.35018L16.0837 7.0656L12.542 10.5152L13.3778 15.3885L9.00033 13.0864L4.62283 15.3885L5.45866 10.5152L1.91699 7.0656L6.81158 6.35018L9.00033 1.91602Z"
        className="icon-stroke"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function FilledStar() {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="#174a84"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.00033 1.91602L11.1891 6.35018L16.0837 7.0656L12.542 10.5152L13.3778 15.3885L9.00033 13.0864L4.62283 15.3885L5.45866 10.5152L1.91699 7.0656L6.81158 6.35018L9.00033 1.91602Z"
        className="icon-stroke"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function BookMeck() {
  return (
    <svg
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.62533 1.33398H11.8337L16.792 7.00065L11.8337 12.6673H2.62533C2.2496 12.6673 1.88927 12.5181 1.62359 12.2524C1.35792 11.9867 1.20866 11.6264 1.20866 11.2506V2.75065C1.20866 2.37493 1.35792 2.01459 1.62359 1.74892C1.88927 1.48324 2.2496 1.33398 2.62533 1.33398V1.33398Z"
        className="icon-stroke"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function Mail() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
        className="icon-stroke"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 6L12 13L2 6"
        className="icon-stroke"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function Send() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6663 1.33398L7.33301 8.66732"
        className="icon-stroke"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6663 1.33398L9.99967 14.6673L7.33301 8.66732L1.33301 6.00065L14.6663 1.33398Z"
        className="icon-stroke"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function CircleTick() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 11.0799V11.9999C21.9988 14.1563 21.3005 16.2545 20.0093 17.9817C18.7182 19.7088 16.9033 20.9723 14.8354 21.5838C12.7674 22.1952 10.5573 22.1218 8.53447 21.3744C6.51168 20.6271 4.78465 19.246 3.61096 17.4369C2.43727 15.6279 1.87979 13.4879 2.02168 11.3362C2.16356 9.18443 2.99721 7.13619 4.39828 5.49694C5.79935 3.85768 7.69279 2.71525 9.79619 2.24001C11.8996 1.76477 14.1003 1.9822 16.07 2.85986"
        className="icon-stroke"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 4L12 14.01L9 11.01"
        className="icon-stroke"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function CircleCross() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        className="icon-stroke"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 9L9 15"
        className="icon-stroke"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 9L15 15"
        className="icon-stroke"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function PlusIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 5V19"
        className="icon-stroke"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 12H19"
        className="icon-stroke"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function MinusIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 6L6 18"
        className="icon-stroke"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 6L18 18"
        className="icon-stroke"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function ChevronUp() {
  return (
    <svg
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 7L7 1L1 7"
        className="icon-stroke"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function AddIcon() {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9192 5V19"
        stroke="#2F80ED"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.91919 12H19.9192"
        stroke="#2F80ED"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function RemoveIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 6L6 18"
        stroke="#EB5757"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 6L18 18"
        stroke="#EB5757"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function download() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.75 11.25V14.25C15.75 14.6478 15.592 15.0294 15.3107 15.3107C15.0294 15.592 14.6478 15.75 14.25 15.75H3.75C3.35218 15.75 2.97064 15.592 2.68934 15.3107C2.40804 15.0294 2.25 14.6478 2.25 14.25V11.25"
        stroke="#2F80ED"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.25 7.5L9 11.25L12.75 7.5"
        stroke="#2F80ED"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 11.25V2.25"
        stroke="#2F80ED"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function mailIcon() {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.14648 4H20.1465C21.2465 4 22.1465 4.9 22.1465 6V18C22.1465 19.1 21.2465 20 20.1465 20H4.14648C3.04648 20 2.14648 19.1 2.14648 18V6C2.14648 4.9 3.04648 4 4.14648 4Z"
        stroke="#2D5179"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.1465 6L12.1465 13L2.14648 6"
        stroke="#2D5179"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function mailIconSuccess() {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.14648 4H20.1465C21.2465 4 22.1465 4.9 22.1465 6V18C22.1465 19.1 21.2465 20 20.1465 20H4.14648C3.04648 20 2.14648 19.1 2.14648 18V6C2.14648 4.9 3.04648 4 4.14648 4Z"
        stroke="#00B050"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.1465 6L12.1465 13L2.14648 6"
        stroke="#00B050"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Close() {
  return (
    <svg
      width="11"
      height="10"
      viewBox="0 0 11 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 2.5L3 7.5"
        stroke="#2D5179"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 2.5L8 7.5"
        stroke="#2D5179"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function IconExpand() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.7705 0.00187292L12.9326 0.602785C12.7638 0.623242 12.6948 0.827808 12.8124 0.947991L14.2111 2.34671L10.286 6.27182C10.2479 6.31027 10.2266 6.36219 10.2266 6.4163C10.2266 6.4704 10.2479 6.52232 10.286 6.56077L11.4392 7.71401C11.5185 7.79328 11.6489 7.79328 11.7282 7.71401L15.6558 3.78634L17.0546 5.18506C17.0816 5.21204 17.1156 5.23086 17.1528 5.23937C17.19 5.24789 17.2288 5.24575 17.2649 5.23321C17.3009 5.22066 17.3327 5.19822 17.3565 5.16844C17.3804 5.13867 17.3954 5.10278 17.3998 5.06488L17.9981 0.229452C18.0024 0.198572 17.9994 0.167131 17.9895 0.13759C17.9795 0.108048 17.9629 0.081207 17.9408 0.0591671C17.9188 0.0371273 17.892 0.0204862 17.8624 0.0105466C17.8329 0.000606982 17.8014 -0.0023615 17.7705 0.00187292ZM6.56033 10.2864C6.52188 10.2484 6.46996 10.227 6.41586 10.227C6.36175 10.227 6.30983 10.2484 6.27138 10.2864L2.34627 14.2141L0.947551 12.8154C0.920565 12.7884 0.886524 12.7696 0.849332 12.7611C0.812139 12.7526 0.7733 12.7547 0.737267 12.7672C0.701234 12.7798 0.669465 12.8022 0.645602 12.832C0.621738 12.8618 0.606747 12.8977 0.602346 12.9356L0.0014334 17.771C-0.013909 17.904 0.096045 18.0139 0.229013 17.9986L5.067 17.3977C5.23577 17.3772 5.30481 17.1726 5.18718 17.0525L3.78846 15.6537L7.71613 11.7261C7.7954 11.6468 7.7954 11.5164 7.71613 11.4371L6.56033 10.2864Z"
        fill="#2D5179"
      />
    </svg>
  );
}
export function CopyIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.4375 16.75C15.4375 17.4462 15.1609 18.1139 14.6687 18.6062C14.1764 19.0984 13.5087 19.375 12.8125 19.375H3.625C2.92881 19.375 2.26113 19.0984 1.76884 18.6062C1.27656 18.1139 1 17.4462 1 16.75V7.5625C1 6.86631 1.27656 6.19863 1.76884 5.70634C2.26113 5.21406 2.92881 4.9375 3.625 4.9375V6.25C3.2769 6.25 2.94306 6.38828 2.69692 6.63442C2.45078 6.88056 2.3125 7.2144 2.3125 7.5625V16.75C2.3125 17.0981 2.45078 17.4319 2.69692 17.6781C2.94306 17.9242 3.2769 18.0625 3.625 18.0625H12.8125C13.1606 18.0625 13.4944 17.9242 13.7406 17.6781C13.9867 17.4319 14.125 17.0981 14.125 16.75H15.4375Z"
        fill="#2F80ED"
        stroke="#2F80ED"
        strokeWidth="0.5"
      />
      <path
        d="M7.5625 2.3125C7.2144 2.3125 6.88056 2.45078 6.63442 2.69692C6.38828 2.94306 6.25 3.2769 6.25 3.625V12.8125C6.25 13.1606 6.38828 13.4944 6.63442 13.7406C6.88056 13.9867 7.2144 14.125 7.5625 14.125H16.75C17.0981 14.125 17.4319 13.9867 17.6781 13.7406C17.9242 13.4944 18.0625 13.1606 18.0625 12.8125V3.625C18.0625 3.2769 17.9242 2.94306 17.6781 2.69692C17.4319 2.45078 17.0981 2.3125 16.75 2.3125H7.5625ZM7.5625 1H16.75C17.4462 1 18.1139 1.27656 18.6062 1.76884C19.0984 2.26113 19.375 2.92881 19.375 3.625V12.8125C19.375 13.5087 19.0984 14.1764 18.6062 14.6687C18.1139 15.1609 17.4462 15.4375 16.75 15.4375H7.5625C6.86631 15.4375 6.19863 15.1609 5.70634 14.6687C5.21406 14.1764 4.9375 13.5087 4.9375 12.8125V3.625C4.9375 2.92881 5.21406 2.26113 5.70634 1.76884C6.19863 1.27656 6.86631 1 7.5625 1Z"
        fill="#2F80ED"
        stroke="#2F80ED"
        strokeWidth="0.5"
      />
    </svg>
  );
}
export function IconCross() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="red"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 6L6 18"
        stroke="#2D5179"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 6L18 18"
        stroke="#2D5179"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function IconAlert() {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.827 16.1598C16.8896 10.9715 13.951 5.78321 11.0131 0.594936C10.9151 0.415381 10.7683 0.265084 10.5885 0.160245C10.4087 0.0554055 10.2027 0 9.99277 0C9.7828 0 9.57682 0.0554055 9.39703 0.160245C9.21723 0.265084 9.07043 0.415381 8.97246 0.594936C6.03481 5.78321 3.09466 10.9715 0.158576 16.1598C-0.296041 16.9611 0.283416 18 1.17795 18H18.8088C19.3044 18 19.6374 17.7419 19.811 17.3919C20.0294 17.0585 20.0879 16.616 19.8282 16.1591"
        fill="#FFDD15"
      />
      <path
        d="M9.0475 10.3986L8.76935 6.38655C8.71741 5.60514 8.69238 5.04365 8.69238 4.70301C8.69238 4.23894 8.81754 3.87803 9.06847 3.61756C9.32034 3.3586 9.65137 3.22852 10.0619 3.22852C10.5572 3.22852 10.8898 3.39521 11.0562 3.72647C11.2242 4.05985 11.3093 4.53844 11.3093 5.16376C11.3093 5.53132 11.2887 5.90585 11.2474 6.28551L10.875 10.4147C10.8347 10.9066 10.7486 11.2835 10.6163 11.5458C10.483 11.8093 10.2634 11.9394 9.95643 11.9394C9.64605 11.9394 9.42766 11.8126 9.30813 11.5591C9.18517 11.3047 9.09913 10.9177 9.0475 10.3986ZM10.0087 15.9097C9.65668 15.9097 9.34975 15.8002 9.08661 15.579C8.82348 15.3588 8.69238 15.0502 8.69238 14.6539C8.69238 14.3081 8.81754 14.0126 9.06847 13.7702C9.32034 13.5264 9.62727 13.4054 9.99178 13.4054C10.3563 13.4054 10.6654 13.5264 10.9232 13.7702C11.1782 14.0126 11.3093 14.3081 11.3093 14.6539C11.3093 15.0442 11.1782 15.3521 10.9195 15.5748C10.6707 15.794 10.3452 15.9137 10.0087 15.9097Z"
        fill="#1F2E35"
      />
    </svg>
  );
}

export function IconFile() {
  return (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M59.9998 49.7141V25.7141L42.8569 8.57129H25.7141C23.8954 8.57129 22.1513 9.29374 20.8653 10.5797C19.5794 11.8657 18.8569 13.6098 18.8569 15.4284V49.7141C18.8569 51.5328 19.5794 53.2769 20.8653 54.5629C22.1513 55.8488 23.8954 56.5713 25.7141 56.5713H53.1426C54.9613 56.5713 56.7054 55.8488 57.9914 54.5629C59.2773 53.2769 59.9998 51.5328 59.9998 49.7141Z"
        stroke="#2D5179"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.8571 15.4284C17.0385 15.4284 15.2944 16.1509 14.0084 17.4368C12.7224 18.7228 12 20.4669 12 22.2856V56.5713C12 58.3899 12.7224 60.1341 14.0084 61.42C15.2944 62.706 17.0385 63.4284 18.8571 63.4284H46.2857C48.1043 63.4284 49.8485 62.706 51.1344 61.42C52.4204 60.1341 53.1429 58.3899 53.1429 56.5713M42.8571 8.57129V18.857C42.8571 20.6756 43.5796 22.4198 44.8656 23.7057C46.1515 24.9917 47.8957 25.7141 49.7143 25.7141H60L42.8571 8.57129Z"
        stroke="#2D5179"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="29.9653"
        y1="33.6626"
        x2="40.3607"
        y2="33.6626"
        stroke="#2D5179"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <line
        x1="29.9653"
        y1="42.0347"
        x2="45.3839"
        y2="42.0347"
        stroke="#2D5179"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function Menu() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 12H21"
        stroke="#174A84"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 6H21"
        stroke="#174A84"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 18H21"
        stroke="#174A84"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function IconSearch16() {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <path
          d="M7.40983 12.6667C10.3485 12.6667 12.7307 10.2789 12.7307 7.33333C12.7307 4.38781 10.3485 2 7.40983 2C4.47121 2 2.08899 4.38781 2.08899 7.33333C2.08899 10.2789 4.47121 12.6667 7.40983 12.6667Z"
          stroke="#2D5179"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.0609 14.0001L11.1677 11.1001"
          stroke="#2D5179"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}
export function IconAttach12() {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.2934 7.86653L8.1667 13.9932C7.41613 14.7438 6.39815 15.1654 5.3367 15.1654C4.27524 15.1654 3.25726 14.7438 2.5067 13.9932C1.75613 13.2426 1.33447 12.2247 1.33447 11.1632C1.33447 10.1017 1.75613 9.08376 2.5067 8.3332L8.63336 2.20653C9.13374 1.70616 9.81239 1.42505 10.52 1.42505C11.2277 1.42505 11.9063 1.70616 12.4067 2.20653C12.9071 2.70691 13.1882 3.38556 13.1882 4.0932C13.1882 4.80084 12.9071 5.47949 12.4067 5.97987L6.27336 12.1065C6.02318 12.3567 5.68385 12.4973 5.33003 12.4973C4.97621 12.4973 4.63688 12.3567 4.3867 12.1065C4.13651 11.8563 3.99596 11.517 3.99596 11.1632C3.99596 10.8094 4.13651 10.4701 4.3867 10.2199L10.0467 4.56653"
        stroke="#2D5179"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function mailIconDanger() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
        stroke="#DF2F2F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 6L12 13L2 6"
        stroke="#DF2F2F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function circleCrossDanger() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke="#DF2F2F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 9L9 15"
        stroke="#DF2F2F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 9L15 15"
        stroke="#DF2F2F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function circleTickDanger() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 11.0799V11.9999C21.9988 14.1563 21.3005 16.2545 20.0093 17.9817C18.7182 19.7088 16.9033 20.9723 14.8354 21.5838C12.7674 22.1952 10.5573 22.1218 8.53447 21.3744C6.51168 20.6271 4.78465 19.246 3.61096 17.4369C2.43727 15.6279 1.87979 13.4879 2.02168 11.3362C2.16356 9.18443 2.99721 7.13619 4.39828 5.49694C5.79935 3.85768 7.69279 2.71525 9.79619 2.24001C11.8996 1.76477 14.1003 1.9822 16.07 2.85986"
        stroke="#00B050"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 4L12 14.01L9 11.01"
        stroke="#00B050"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function IconBuildings() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.1109 6.22266H17.8887V7.77821H24.1109V24.1115H17.8887V25.6671H25.6664V7.77821C25.6664 7.36565 25.5026 6.96999 25.2108 6.67827C24.9191 6.38654 24.5235 6.22266 24.1109 6.22266Z"
        fill="#2F80ED"
      />
      <path
        d="M15.4624 2.33398H4.76022C4.3229 2.33398 3.9035 2.50771 3.59428 2.81693C3.28505 3.12616 3.11133 3.54556 3.11133 3.98287V25.6673H17.1113V3.98287C17.1113 3.54556 16.9376 3.12616 16.6284 2.81693C16.3192 2.50771 15.8998 2.33398 15.4624 2.33398ZM15.5558 24.1118H13.2224V21.7784H7.00022V24.1118H4.66688V3.98287C4.66688 3.97062 4.6693 3.95848 4.67399 3.94716C4.67868 3.93583 4.68555 3.92554 4.69422 3.91688C4.70289 3.90821 4.71318 3.90133 4.7245 3.89664C4.73582 3.89195 4.74796 3.88954 4.76022 3.88954H15.4624C15.4747 3.88954 15.4868 3.89195 15.4982 3.89664C15.5095 3.90133 15.5198 3.90821 15.5284 3.91688C15.5371 3.92554 15.544 3.93583 15.5487 3.94716C15.5534 3.95848 15.5558 3.97062 15.5558 3.98287V24.1118Z"
        fill="#2F80ED"
      />
      <path
        d="M6.22266 6.22266H7.77821V7.77821H6.22266V6.22266Z"
        fill="#2F80ED"
      />
      <path
        d="M9.33301 6.22266H10.8886V7.77821H9.33301V6.22266Z"
        fill="#2F80ED"
      />
      <path
        d="M12.4443 6.22266H13.9999V7.77821H12.4443V6.22266Z"
        fill="#2F80ED"
      />
      <path
        d="M6.22266 10.1113H7.77821V11.6669H6.22266V10.1113Z"
        fill="#2F80ED"
      />
      <path
        d="M9.33301 10.1113H10.8886V11.6669H9.33301V10.1113Z"
        fill="#2F80ED"
      />
      <path
        d="M12.4443 10.1113H13.9999V11.6669H12.4443V10.1113Z"
        fill="#2F80ED"
      />
      <path d="M6.22266 14H7.77821V15.5556H6.22266V14Z" fill="#2F80ED" />
      <path d="M9.33301 14H10.8886V15.5556H9.33301V14Z" fill="#2F80ED" />
      <path d="M12.4443 14H13.9999V15.5556H12.4443V14Z" fill="#2F80ED" />
      <path
        d="M6.22266 17.8887H7.77821V19.4442H6.22266V17.8887Z"
        fill="#2F80ED"
      />
      <path
        d="M9.33301 17.8887H10.8886V19.4442H9.33301V17.8887Z"
        fill="#2F80ED"
      />
      <path
        d="M12.4443 17.8887H13.9999V19.4442H12.4443V17.8887Z"
        fill="#2F80ED"
      />
      <path
        d="M17.8887 10.1113H19.4442V11.6669H17.8887V10.1113Z"
        fill="#2F80ED"
      />
      <path d="M21 10.1113H22.5556V11.6669H21V10.1113Z" fill="#2F80ED" />
      <path d="M17.8887 14H19.4442V15.5556H17.8887V14Z" fill="#2F80ED" />
      <path d="M21 14H22.5556V15.5556H21V14Z" fill="#2F80ED" />
      <path
        d="M17.8887 17.8887H19.4442V19.4442H17.8887V17.8887Z"
        fill="#2F80ED"
      />
      <path d="M21 17.8887H22.5556V19.4442H21V17.8887Z" fill="#2F80ED" />
    </svg>
  );
}
export function IconShip() {
  return (
    <svg
      width="26"
      height="22"
      viewBox="0 0 26 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.28571 0.916667C9.28571 0.673552 9.38355 0.440394 9.55769 0.268486C9.73183 0.0965773 9.96801 0 10.2143 0H15.7857C16.032 0 16.2682 0.0965773 16.4423 0.268486C16.6165 0.440394 16.7143 0.673552 16.7143 0.916667V3.66667H21.3571C21.6034 3.66667 21.8396 3.76324 22.0137 3.93515C22.1879 4.10706 22.2857 4.34022 22.2857 4.58333V11.0403L24.5124 11.9937C24.6309 12.0446 24.7373 12.1195 24.8248 12.2134C24.9123 12.3072 24.979 12.4181 25.0206 12.5389C25.0622 12.6597 25.0778 12.7878 25.0664 12.9149C25.055 13.042 25.0169 13.1653 24.9544 13.277L22.828 17.0555C22.5401 16.5367 22.178 15.9977 21.4444 15.7392L22.8336 13.2715L14.1069 9.53883C13.7575 9.38949 13.3807 9.31244 13 9.31244C12.6193 9.31244 12.2425 9.38949 11.8931 9.53883L3.16643 13.2733L4.55557 15.741C3.82386 15.9995 3.45986 16.5385 3.172 17.0573L1.04557 13.2807C0.981793 13.1688 0.942535 13.0449 0.93034 12.9171C0.918145 12.7893 0.933285 12.6603 0.974779 12.5387C1.01627 12.417 1.0832 12.3053 1.17121 12.2108C1.25923 12.1162 1.36638 12.041 1.48571 11.99L3.71429 11.0385V4.58333C3.71429 4.34022 3.81212 4.10706 3.98626 3.93515C4.1604 3.76324 4.39658 3.66667 4.64286 3.66667H9.28571V0.916667ZM5.57143 10.2447L11.154 7.85767C11.7367 7.60841 12.365 7.47981 13 7.47981C13.635 7.47981 14.2633 7.60841 14.846 7.85767L20.4286 10.2447V5.5H5.57143V10.2447ZM14.8571 1.83333H11.1429V3.66667H14.8571V1.83333ZM4.83229 17.7797C4.80938 17.8089 4.7883 17.8395 4.76914 17.8713C4.72701 17.9465 4.68979 18.0243 4.65771 18.1042C4.62817 18.1774 4.59469 18.249 4.55743 18.3187C4.40217 18.5903 4.20969 18.8396 3.98543 19.0593C3.45429 19.5873 2.52571 20.1667 0.928571 20.1667C0.682299 20.1667 0.446113 20.2632 0.271972 20.4352C0.0978313 20.6071 0 20.8402 0 21.0833C0 21.3264 0.0978313 21.5596 0.271972 21.7315C0.446113 21.9034 0.682299 22 0.928571 22C3.04757 22 4.44043 21.2043 5.30029 20.3573C5.38014 20.2767 5.45629 20.1978 5.52686 20.119C5.57329 20.1758 5.61971 20.2363 5.66986 20.295C6.37 21.1237 7.54 22 9.28571 22C11.0314 22 12.2014 21.1237 12.9016 20.295L13 20.174L13.0984 20.295C13.7986 21.1237 14.9686 22 16.7143 22C18.46 22 19.63 21.1237 20.3301 20.295C20.3803 20.2363 20.4267 20.1758 20.4731 20.1172C20.5437 20.196 20.6199 20.2767 20.6997 20.3555C21.5596 21.2043 22.9524 22 25.0714 22C25.3177 22 25.5539 21.9034 25.728 21.7315C25.9022 21.5596 26 21.3264 26 21.0833C26 20.8402 25.9022 20.6071 25.728 20.4352C25.5539 20.2632 25.3177 20.1667 25.0714 20.1667C23.4761 20.1667 22.5476 19.5873 22.0146 19.0593C21.7146 18.768 21.4749 18.4217 21.3089 18.04C21.2456 17.8595 21.1269 17.7029 20.9693 17.592C20.8117 17.4812 20.623 17.4216 20.4295 17.4216C20.236 17.4216 20.0473 17.4812 19.8897 17.592C19.7321 17.7029 19.6134 17.8595 19.5501 18.04C19.3934 18.4317 19.1753 18.7967 18.9039 19.1217C18.4414 19.668 17.7524 20.1667 16.7124 20.1667C15.6743 20.1667 14.9853 19.668 14.5247 19.1217C14.2555 18.7992 14.0387 18.4374 13.8821 18.0492C13.8435 17.93 13.7805 17.82 13.6969 17.7259C13.6133 17.6319 13.511 17.5558 13.3964 17.5025C13.2818 17.4492 13.1572 17.4198 13.0306 17.416C12.9039 17.4123 12.7778 17.4344 12.6601 17.4808C12.5324 17.5298 12.4173 17.6061 12.3232 17.7044C12.229 17.8027 12.1583 17.9205 12.116 18.0492C11.9594 18.4374 11.7427 18.7992 11.4734 19.1217C11.0129 19.668 10.3257 20.1667 9.28571 20.1667C8.24571 20.1667 7.55857 19.668 7.098 19.1217C6.89982 18.8849 6.72971 18.6266 6.591 18.3517C6.55707 18.284 6.52609 18.2148 6.49814 18.1445C6.461 18.0528 6.42386 17.9575 6.37371 17.8732C6.26014 17.6803 6.07922 17.5349 5.86486 17.4643L5.85557 17.4607C5.6726 17.4019 5.47561 17.4011 5.29214 17.4583C5.10867 17.5155 4.94789 17.6278 4.83229 17.7797Z"
        fill="#2F80ED"
      />
    </svg>
  );
}
export function IconSend() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6663 1.33398L9.99967 14.6673L7.33301 8.66732L1.33301 6.00065L14.6663 1.33398Z"
        stroke="#2D5179"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function Iconinfo() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00001 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8.00004C14.6667 4.31814 11.6819 1.33337 8.00001 1.33337C4.31811 1.33337 1.33334 4.31814 1.33334 8.00004C1.33334 11.6819 4.31811 14.6667 8.00001 14.6667Z"
        className="icon-stroke"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 10.6667V8"
        className="icon-stroke"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 5.33337H8.00667"
        className="icon-stroke"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function IconUpload() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.75 11.25V14.25C15.75 14.6478 15.592 15.0294 15.3107 15.3107C15.0294 15.592 14.6478 15.75 14.25 15.75H3.75C3.35218 15.75 2.97064 15.592 2.68934 15.3107C2.40804 15.0294 2.25 14.6478 2.25 14.25V11.25"
        stroke="#2F80ED"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.75 6L9 2.25L5.25 6"
        stroke="#2F80ED"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 2.25V11.25"
        stroke="#2F80ED"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function IconPencil() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 20H21"
        stroke="#2D5179"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 3.50023C16.8978 3.1024 17.4374 2.87891 18 2.87891C18.2786 2.87891 18.5544 2.93378 18.8118 3.04038C19.0692 3.14699 19.303 3.30324 19.5 3.50023C19.697 3.69721 19.8532 3.93106 19.9598 4.18843C20.0665 4.4458 20.1213 4.72165 20.1213 5.00023C20.1213 5.2788 20.0665 5.55465 19.9598 5.81202C19.8532 6.06939 19.697 6.30324 19.5 6.50023L7 19.0002L3 20.0002L4 16.0002L16.5 3.50023Z"
        stroke="#2D5179"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function IconDelete() {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 4.5H3.33333H14"
        className="icon-stroke"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33325 4.50065V3.16732C5.33325 2.8137 5.47373 2.47456 5.72378 2.22451C5.97383 1.97446 6.31296 1.83398 6.66659 1.83398H9.33325C9.68687 1.83398 10.026 1.97446 10.2761 2.22451C10.5261 2.47456 10.6666 2.8137 10.6666 3.16732V4.50065M12.6666 4.50065V13.834C12.6666 14.1876 12.5261 14.5267 12.2761 14.7768C12.026 15.0268 11.6869 15.1673 11.3333 15.1673H4.66659C4.31296 15.1673 3.97382 15.0268 3.72378 14.7768C3.47373 14.5267 3.33325 14.1876 3.33325 13.834V4.50065H12.6666Z"
        className="icon-stroke"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function IconEyeOpen() {
  return (
    <svg
      width="14"
      height="9"
      viewBox="0 0 14 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.0002 3.00299C7.35044 3.00299 7.69724 3.07198 8.02082 3.20601C8.34439 3.34003 8.6384 3.53648 8.88605 3.78414C9.13371 4.03179 9.33016 4.3258 9.46419 4.64938C9.59822 4.97295 9.6672 5.31976 9.6672 5.66999C9.6672 6.02023 9.59822 6.36703 9.46419 6.69061C9.33016 7.01418 9.13371 7.30819 8.88605 7.55585C8.6384 7.8035 8.34439 7.99995 8.02082 8.13398C7.69724 8.26801 7.35044 8.33699 7.0002 8.33699C6.29287 8.33699 5.61451 8.05601 5.11435 7.55585C4.61419 7.05569 4.3332 6.37733 4.3332 5.66999C4.3332 4.96266 4.61419 4.2843 5.11435 3.78414C5.61451 3.28398 6.29287 3.00299 7.0002 3.00299ZM7.0002 4.00299C6.55808 4.00299 6.13408 4.17862 5.82145 4.49125C5.50883 4.80387 5.3332 5.22788 5.3332 5.66999C5.3332 6.11211 5.50883 6.53612 5.82145 6.84874C6.13408 7.16136 6.55808 7.33699 7.0002 7.33699C7.44232 7.33699 7.86632 7.16136 8.17895 6.84874C8.49157 6.53612 8.6672 6.11211 8.6672 5.66999C8.6672 5.22788 8.49157 4.80387 8.17895 4.49125C7.86632 4.17862 7.44232 4.00299 7.0002 4.00299ZM7.0002 0.666992C10.0762 0.666992 12.7302 2.76699 13.4672 5.70999C13.4848 5.77426 13.4894 5.84139 13.4807 5.90746C13.472 5.97352 13.4502 6.03718 13.4166 6.0947C13.3829 6.15222 13.3381 6.20243 13.2848 6.24238C13.2315 6.28233 13.1707 6.31122 13.106 6.32735C13.0414 6.34348 12.9742 6.34653 12.9083 6.33631C12.8425 6.32609 12.7793 6.30281 12.7226 6.26784C12.6659 6.23287 12.6167 6.18691 12.578 6.13267C12.5393 6.07843 12.5118 6.017 12.4972 5.95199C12.1878 4.72827 11.4789 3.64278 10.4828 2.8675C9.48669 2.09222 8.26038 1.67148 6.99814 1.67194C5.7359 1.6724 4.5099 2.09403 3.51438 2.87003C2.51886 3.64604 1.81074 4.73204 1.5022 5.95599C1.46921 6.08379 1.38703 6.19337 1.27357 6.26081C1.16012 6.32826 1.0246 6.34812 0.896565 6.31604C0.768532 6.28397 0.658374 6.20257 0.590117 6.0896C0.52186 5.97663 0.501041 5.84125 0.5322 5.71299C0.893895 4.27145 1.72676 2.99203 2.89856 2.07785C4.07037 1.16366 5.51397 0.667103 7.0002 0.666992Z"
        fill="black"
      />
    </svg>
  );
}
export function IconEyeClose() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.479893 0.480011C0.395339 0.564589 0.343902 0.676673 0.334911 0.795929C0.325921 0.915185 0.359975 1.03371 0.430893 1.13001L0.479893 1.18701L3.16989 3.87701C1.8585 4.79594 0.922281 6.15677 0.532893 7.71001C0.504221 7.83743 0.526542 7.97101 0.595083 8.08218C0.663624 8.19335 0.772943 8.2733 0.899663 8.30491C1.02638 8.33652 1.16044 8.3173 1.27317 8.25135C1.3859 8.1854 1.46835 8.07796 1.50289 7.95201C1.84866 6.57345 2.70041 5.37543 3.88889 4.59601L5.09589 5.80301C4.61172 6.30632 4.34428 6.97946 4.35105 7.67781C4.35781 8.37617 4.63823 9.044 5.13207 9.53784C5.6259 10.0317 6.29374 10.3121 6.99209 10.3189C7.69044 10.3256 8.36359 10.0582 8.86689 9.57401L12.8129 13.52C12.9021 13.6089 13.0216 13.6608 13.1474 13.6654C13.2733 13.67 13.3962 13.627 13.4917 13.5449C13.5872 13.4628 13.6482 13.3477 13.6625 13.2226C13.6768 13.0975 13.6434 12.9715 13.5689 12.87L13.5199 12.813L9.44489 8.73701V8.73601L8.64489 7.93701L6.73189 6.02401H6.73289L4.81289 4.10501V4.10401L4.05789 3.35001L1.18689 0.480011C1.09313 0.386276 0.965975 0.333618 0.833393 0.333618C0.700811 0.333618 0.573657 0.386276 0.479893 0.480011ZM5.80289 6.51001L8.15889 8.86701C7.8442 9.16908 7.42364 9.33576 6.98746 9.33129C6.55128 9.32683 6.13422 9.15157 5.82578 8.84313C5.51733 8.53468 5.34208 8.11763 5.33761 7.68145C5.33315 7.24526 5.49983 6.82471 5.80189 6.51001H5.80289ZM6.99989 2.66701C6.33289 2.66701 5.68589 2.76501 5.07389 2.95001L5.89889 3.77401C7.32531 3.49147 8.80575 3.76785 10.0341 4.54601C11.2625 5.32418 12.1449 6.54462 12.4989 7.95501C12.5334 8.08097 12.6159 8.18841 12.7286 8.25435C12.8413 8.3203 12.9754 8.33952 13.1021 8.30791C13.2288 8.2763 13.3382 8.19635 13.4067 8.08518C13.4752 7.97401 13.4976 7.84043 13.4689 7.71301C13.1072 6.2713 12.2741 4.99176 11.1021 4.07756C9.93012 3.16336 8.48629 2.6669 6.99989 2.66701ZM7.12989 5.00701L9.66389 7.54001C9.63142 6.87844 9.35402 6.25261 8.88566 5.78424C8.4173 5.31588 7.79146 5.03848 7.12989 5.00601V5.00701Z"
        fill="black"
      />
    </svg>
  );
}

export function filetypeIcon() {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.8">
        <path
          d="M13.4583 2.625H3.54167C2.75926 2.625 2.125 3.25926 2.125 4.04167V13.9583C2.125 14.7407 2.75926 15.375 3.54167 15.375H13.4583C14.2407 15.375 14.875 14.7407 14.875 13.9583V4.04167C14.875 3.25926 14.2407 2.625 13.4583 2.625Z"
          stroke="#585C64"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.02051 7.58203C6.60731 7.58203 7.08301 7.10633 7.08301 6.51953C7.08301 5.93273 6.60731 5.45703 6.02051 5.45703C5.43371 5.45703 4.95801 5.93273 4.95801 6.51953C4.95801 7.10633 5.43371 7.58203 6.02051 7.58203Z"
          stroke="#585C64"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.8753 11.1237L11.3337 7.58203L3.54199 15.3737"
          stroke="#585C64"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}
export function ArchiveIcon() {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.8" clipPath="url(#clip0_5617_121348)">
        <path
          d="M14.875 6.16797V15.3763H2.125V6.16797"
          stroke="#2F80ED"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.2918 2.625H0.708496V6.16667H16.2918V2.625Z"
          stroke="#2F80ED"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.0835 9H9.91683"
          stroke="#2F80ED"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5617_121348">
          <rect
            width="17"
            height="17"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export function ErrorIcon() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 122 122"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M61 92.8217C63.4893 92.8217 65.5072 90.8037 65.5072 88.3144C65.5072 85.8252 63.4893 83.8072 61 83.8072C58.5108 83.8072 56.4928 85.8252 56.4928 88.3144C56.4928 90.8037 58.5108 92.8217 61 92.8217Z"
        fill="#2D5179"
      />
      <path
        d="M61 76.6228C60.1012 76.6228 59.2392 76.2657 58.6037 75.6302C57.9681 74.9947 57.6111 74.1327 57.6111 73.2339V32.5672C57.6111 31.6684 57.9681 30.8065 58.6037 30.1709C59.2392 29.5354 60.1012 29.1783 61 29.1783C61.8988 29.1783 62.7607 29.5354 63.3963 30.1709C64.0318 30.8065 64.3889 31.6684 64.3889 32.5672V73.2339C64.3889 74.1327 64.0318 74.9947 63.3963 75.6302C62.7607 76.2657 61.8988 76.6228 61 76.6228Z"
        fill="#2D5179"
      />
      <path
        d="M61 115.222C50.2759 115.222 39.7926 112.042 30.8758 106.084C21.959 100.126 15.0092 91.6578 10.9052 81.75C6.80126 71.8421 5.72748 60.9399 7.81966 50.4218C9.91184 39.9037 15.076 30.2422 22.6591 22.6591C30.2422 15.076 39.9037 9.91182 50.4218 7.81964C60.9399 5.72747 71.8421 6.80125 81.75 10.9052C91.6578 15.0092 100.126 21.959 106.084 30.8757C112.042 39.7925 115.222 50.2759 115.222 61C115.222 75.3806 109.51 89.1723 99.3409 99.3409C89.1723 109.51 75.3807 115.222 61 115.222ZM61 13.5556C51.6164 13.5556 42.4435 16.3381 34.6413 21.5514C26.8391 26.7647 20.758 34.1745 17.1671 42.8438C13.5761 51.5131 12.6366 61.0526 14.4672 70.256C16.2979 79.4593 20.8165 87.9131 27.4517 94.5483C34.087 101.184 42.5407 105.702 51.7441 107.533C60.9474 109.363 70.4869 108.424 79.1562 104.833C87.8256 101.242 95.2354 95.1609 100.449 87.3587C105.662 79.5565 108.444 70.3836 108.444 61C108.444 48.417 103.446 36.3493 94.5483 27.4517C85.6507 18.5542 73.5831 13.5556 61 13.5556Z"
        fill="#2D5179"
      />
    </svg>
  );
}
export function IconEdit() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 20H21"
        className="icon-stroke"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 3.50023C16.8978 3.1024 17.4374 2.87891 18 2.87891C18.2786 2.87891 18.5544 2.93378 18.8118 3.04038C19.0692 3.14699 19.303 3.30324 19.5 3.50023C19.697 3.69721 19.8532 3.93106 19.9598 4.18843C20.0665 4.4458 20.1213 4.72165 20.1213 5.00023C20.1213 5.2788 20.0665 5.55465 19.9598 5.81202C19.8532 6.06939 19.697 6.30324 19.5 6.50023L7 19.0002L3 20.0002L4 16.0002L16.5 3.50023Z"
        className="icon-stroke"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function downArrow() {
  return (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1L5 5L9 1"
        stroke="#2D5179"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function toastCloseIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 5L5 15"
        stroke="#2D5179"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 5L15 15"
        stroke="#2D5179"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function AttachBlueIcon() {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.4403 11.0499L11.2503 20.2399C10.1244 21.3658 8.59747 21.9983 7.00529 21.9983C5.41311 21.9983 3.88613 21.3658 2.76029 20.2399C1.63445 19.1141 1.00195 17.5871 1.00195 15.9949C1.00195 14.4027 1.63445 12.8758 2.76029 11.7499L11.9503 2.55992C12.7009 1.80936 13.7188 1.3877 14.7803 1.3877C15.8417 1.3877 16.8597 1.80936 17.6103 2.55992C18.3609 3.31048 18.7825 4.32846 18.7825 5.38992C18.7825 6.45138 18.3609 7.46936 17.6103 8.21992L8.41029 17.4099C8.03501 17.7852 7.52602 17.996 6.99529 17.996C6.46456 17.996 5.95557 17.7852 5.58029 17.4099C5.20501 17.0346 4.99418 16.5256 4.99418 15.9949C4.99418 15.4642 5.20501 14.9552 5.58029 14.5799L14.0703 6.09992"
        stroke="#2F80ED"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function ReplayIcon() {
  return (
    <svg
      width="17"
      height="13"
      viewBox="0 0 17 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.19912 0L0.411441 4.78849L0 5.21871L0.411441 5.64892L5.19912 10.4374L6.05941 9.57698L1.70187 5.21871L6.05941 0.860432L5.19912 0ZM8.19142 0L3.40374 4.78849L2.9923 5.21871L3.40374 5.64892L8.19142 10.4374L9.05171 9.57698L5.29263 5.81727H12.8108C14.4707 5.81727 15.8031 7.14986 15.8031 8.81007C15.8031 10.4703 14.4707 11.8029 12.8108 11.8029V13C15.1174 13 17 11.1171 17 8.81007C17 6.50302 15.1174 4.62014 12.8108 4.62014H5.29263L9.05171 0.860432L8.19142 0Z"
        fill="#2F80ED"
      />
    </svg>
  );
}
export function IconPDF() {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.0759 2.41211L22.2489 6.76211V23.3041H6.66016V23.3581H22.3022V6.81686L18.0759 2.41211Z"
        fill="#909090"
      />
      <path
        d="M18.0227 2.35742H6.60547V23.3034H22.2475V6.76217L18.022 2.35742"
        fill="#F4F4F4"
      />
      <path
        d="M6.49172 3.48242H1.69922V8.60267H16.7742V3.48242H6.49172Z"
        fill="#7A7B7C"
      />
      <path d="M16.8546 8.5156H1.79688V3.3916H16.8546V8.5156Z" fill="#DD2025" />
      <path
        d="M6.78884 4.25843H5.80859V7.85843H6.57959V6.64418L6.74984 6.65393C6.91527 6.65108 7.07915 6.62145 7.23509 6.56618C7.37182 6.51915 7.4976 6.44491 7.60484 6.34793C7.71397 6.25554 7.8 6.13894 7.85609 6.00743C7.93132 5.7888 7.95818 5.55645 7.93484 5.32643C7.93016 5.16211 7.90135 4.99937 7.84934 4.84343C7.802 4.73086 7.73174 4.62938 7.64303 4.54545C7.55432 4.46152 7.44911 4.39697 7.33409 4.35593C7.23465 4.31993 7.13191 4.2938 7.02734 4.27793C6.94816 4.26571 6.86821 4.25919 6.78809 4.25843H6.78884ZM6.64634 5.97893H6.57959V4.86893H6.72434C6.78823 4.86432 6.85233 4.87413 6.91192 4.89762C6.9715 4.92112 7.02505 4.95771 7.06859 5.00468C7.15883 5.12544 7.20704 5.27243 7.20584 5.42318C7.20584 5.60768 7.20584 5.77493 7.03934 5.89268C6.91939 5.95865 6.78286 5.98835 6.64634 5.97818V5.97893ZM9.39959 4.24868C9.31634 4.24868 9.23534 4.25468 9.17834 4.25693L8.99984 4.26143H8.41484V7.86143H9.10334C9.36646 7.86864 9.62843 7.82404 9.87434 7.73018C10.0723 7.65167 10.2476 7.52511 10.3843 7.36193C10.5174 7.19727 10.6128 7.00555 10.6641 6.80018C10.723 6.56758 10.7518 6.32836 10.7496 6.08843C10.7641 5.80504 10.7422 5.52097 10.6843 5.24318C10.6294 5.0387 10.5266 4.85025 10.3843 4.69343C10.2727 4.5668 10.1361 4.46465 9.98309 4.39343C9.85168 4.33261 9.71344 4.28779 9.57134 4.25993C9.51484 4.25059 9.45761 4.24633 9.40034 4.24718L9.39959 4.24868ZM9.26384 7.19993H9.18884V4.90193H9.19859C9.35321 4.88414 9.50966 4.91204 9.64859 4.98218C9.75034 5.06342 9.83325 5.16578 9.89159 5.28218C9.95456 5.40468 9.99086 5.53913 9.99809 5.67668C10.0048 5.84168 9.99809 5.97668 9.99809 6.08843C10.0011 6.21715 9.99287 6.3459 9.97334 6.47318C9.95023 6.60385 9.9075 6.73028 9.84659 6.84818C9.77766 6.95779 9.68453 7.05016 9.57434 7.11818C9.48181 7.17803 9.37223 7.20595 9.26234 7.19768L9.26384 7.19993ZM13.0723 4.26143H11.2498V7.86143H12.0208V6.43343H12.9958V5.76443H12.0208V4.93043H13.0708V4.26143"
        fill="#464648"
      />
      <path
        d="M16.3365 16.0495C16.3365 16.0495 18.7275 15.616 18.7275 16.4328C18.7275 17.2495 17.2462 16.9173 16.3365 16.0495ZM14.5687 16.1118C14.1889 16.1957 13.8187 16.3186 13.464 16.4785L13.764 15.8035C14.064 15.1285 14.3752 14.2083 14.3752 14.2083C14.7332 14.8108 15.1497 15.3765 15.6187 15.8973C15.2651 15.95 14.9145 16.0221 14.5687 16.1133V16.1118ZM13.6222 11.2368C13.6222 10.525 13.8525 10.3308 14.0317 10.3308C14.211 10.3308 14.4127 10.417 14.4195 11.035C14.3611 11.6565 14.231 12.269 14.0317 12.8605C13.7588 12.3639 13.6176 11.8057 13.6215 11.239L13.6222 11.2368ZM10.1355 19.1238C9.40199 18.685 11.6737 17.3343 12.0855 17.2908C12.0832 17.2915 10.9035 19.5828 10.1355 19.1238ZM19.4257 16.5295C19.4182 16.4545 19.3507 15.6243 17.8732 15.6595C17.2574 15.6496 16.6419 15.693 16.0335 15.7893C15.4442 15.1956 14.9367 14.5259 14.5245 13.798C14.7842 13.0476 14.9414 12.2655 14.9917 11.473C14.97 10.573 14.7547 10.057 14.0647 10.0645C13.3747 10.072 13.2742 10.6758 13.365 11.5743C13.4539 12.1781 13.6216 12.7676 13.8637 13.3278C13.8637 13.3278 13.545 14.32 13.1235 15.307C12.702 16.294 12.414 16.8115 12.414 16.8115C11.681 17.0501 10.991 17.4046 10.3702 17.8615C9.75225 18.4368 9.501 18.8785 9.8265 19.3203C10.107 19.7013 11.0887 19.7875 11.9662 18.6378C12.4325 18.0439 12.8584 17.4195 13.2412 16.7688C13.2412 16.7688 14.5792 16.402 14.9955 16.3015C15.4117 16.201 15.915 16.1215 15.915 16.1215C15.915 16.1215 17.1367 17.3508 18.315 17.3073C19.4932 17.2638 19.4362 16.603 19.4287 16.531"
        fill="#DD2025"
      />
      <path
        d="M17.9648 2.41406V6.81881H22.1896L17.9648 2.41406Z"
        fill="#909090"
      />
      <path
        d="M18.0234 2.35742V6.76217H22.2482L18.0234 2.35742Z"
        fill="#F4F4F4"
      />
      <path
        d="M6.73025 4.19983H5.75V7.79983H6.524V6.58633L6.695 6.59608C6.86043 6.59324 7.0243 6.5636 7.18025 6.50833C7.31697 6.46129 7.44275 6.38705 7.55 6.29008C7.65831 6.19745 7.74356 6.08087 7.799 5.94958C7.87422 5.73096 7.90109 5.49861 7.87775 5.26858C7.87307 5.10426 7.84426 4.94152 7.79225 4.78558C7.74491 4.67301 7.67464 4.57153 7.58593 4.4876C7.49723 4.40367 7.39202 4.33913 7.277 4.29808C7.1771 4.26173 7.07385 4.23535 6.96875 4.21933C6.88957 4.20712 6.80961 4.2006 6.7295 4.19983H6.73025ZM6.58775 5.92033H6.521V4.81033H6.6665C6.73039 4.80573 6.79449 4.81553 6.85407 4.83903C6.91366 4.86253 6.9672 4.89911 7.01075 4.94608C7.10099 5.06684 7.1492 5.21384 7.148 5.36458C7.148 5.54908 7.148 5.71633 6.9815 5.83408C6.86155 5.90006 6.72502 5.92976 6.5885 5.91958L6.58775 5.92033ZM9.341 4.19008C9.25775 4.19008 9.17675 4.19608 9.11975 4.19833L8.9435 4.20283H8.3585V7.80283H9.047C9.31012 7.81005 9.57209 7.76545 9.818 7.67158C10.0159 7.59307 10.1912 7.46652 10.328 7.30333C10.461 7.13867 10.5565 6.94696 10.6077 6.74158C10.6667 6.50898 10.6954 6.26977 10.6932 6.02983C10.7078 5.74645 10.6859 5.46237 10.628 5.18458C10.5731 4.9801 10.4702 4.79165 10.328 4.63483C10.2164 4.5082 10.0798 4.40606 9.92675 4.33483C9.79534 4.27402 9.6571 4.2292 9.515 4.20133C9.45849 4.192 9.40127 4.18773 9.344 4.18858L9.341 4.19008ZM9.2075 7.14133H9.1325V4.84333H9.14225C9.29687 4.82554 9.45331 4.85344 9.59225 4.92358C9.694 5.00483 9.7769 5.10718 9.83525 5.22358C9.89822 5.34608 9.93451 5.48054 9.94175 5.61808C9.9485 5.78308 9.94175 5.91808 9.94175 6.02983C9.9448 6.15856 9.93652 6.28731 9.917 6.41458C9.89388 6.54525 9.85115 6.67168 9.79025 6.78958C9.72132 6.8992 9.62819 6.99156 9.518 7.05958C9.42547 7.11943 9.31589 7.14735 9.206 7.13908L9.2075 7.14133ZM13.0138 4.20283H11.1912V7.80283H11.9622V6.37483H12.9372V5.70583H11.9622V4.87183H13.0122V4.20283"
        fill="white"
      />
    </svg>
  );
}
export function IconSettings() {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 2.80721C13 2.11046 12.432 1.5459 11.731 1.5459H10.27C9.568 1.5459 9 2.11046 9 2.80721C9 3.3817 8.604 3.8747 8.065 4.08541C7.98 4.11921 7.895 4.15499 7.812 4.19077C7.281 4.41938 6.65 4.3498 6.24 3.94328C6.00204 3.70693 5.6794 3.57417 5.343 3.57417C5.0066 3.57417 4.68396 3.70693 4.446 3.94328L3.412 4.97101C3.17421 5.20753 3.04064 5.52821 3.04064 5.86258C3.04064 6.19694 3.17421 6.51763 3.412 6.75414C3.822 7.16166 3.892 7.78784 3.66 8.31661C3.62355 8.39983 3.58854 8.48366 3.555 8.56808C3.343 9.10381 2.847 9.49741 2.269 9.49741C1.568 9.49741 1 10.062 1 10.7587V12.2119C1 12.9086 1.568 13.4732 2.269 13.4732C2.847 13.4732 3.343 13.8668 3.555 14.4025C3.589 14.487 3.625 14.5715 3.66 14.654C3.891 15.1818 3.821 15.8089 3.412 16.2164C3.17421 16.453 3.04064 16.7736 3.04064 17.108C3.04064 17.4424 3.17421 17.7631 3.412 17.9996L4.446 19.0273C4.68396 19.2637 5.0066 19.3964 5.343 19.3964C5.6794 19.3964 6.00204 19.2637 6.24 19.0273C6.65 18.6198 7.28 18.5502 7.812 18.7798C7.895 18.8166 7.98 18.8514 8.065 18.8852C8.604 19.0959 9 19.5889 9 20.1634C9 20.8601 9.568 21.4247 10.269 21.4247H11.731C12.432 21.4247 13 20.8601 13 20.1634C13 19.5889 13.396 19.0959 13.935 18.8842C14.02 18.8514 14.105 18.8166 14.188 18.7808C14.719 18.5502 15.35 18.6208 15.759 19.0273C15.8768 19.1445 16.0168 19.2374 16.1708 19.3009C16.3248 19.3643 16.4898 19.3969 16.6565 19.3969C16.8232 19.3969 16.9882 19.3643 17.1422 19.3009C17.2962 19.2374 17.4362 19.1445 17.554 19.0273L18.588 17.9996C18.8258 17.7631 18.9594 17.4424 18.9594 17.108C18.9594 16.7736 18.8258 16.453 18.588 16.2164C18.178 15.8089 18.108 15.1827 18.339 14.654C18.376 14.5715 18.411 14.487 18.445 14.4025C18.657 13.8668 19.153 13.4732 19.731 13.4732C20.432 13.4732 21 12.9086 21 12.2119V10.7597C21 10.063 20.432 9.49841 19.731 9.49841C19.153 9.49841 18.657 9.10481 18.444 8.56907C18.4105 8.48464 18.3755 8.40081 18.339 8.31761C18.109 7.78983 18.179 7.16265 18.588 6.75514C18.8258 6.51862 18.9594 6.19794 18.9594 5.86357C18.9594 5.52921 18.8258 5.20852 18.588 4.97201L17.554 3.94427C17.316 3.70793 16.9934 3.57516 16.657 3.57516C16.3206 3.57516 15.998 3.70793 15.76 3.94427C15.35 4.35179 14.72 4.42137 14.188 4.19177C14.1043 4.1552 14.0199 4.12007 13.935 4.08641C13.396 3.8747 13 3.3817 13 2.8082V2.80721Z"
        stroke="#174A84"
        strokeWidth="2"
      />
      <path
        d="M15 11.4855C15 12.54 14.5786 13.5512 13.8284 14.2968C13.0783 15.0424 12.0609 15.4613 11 15.4613C9.93913 15.4613 8.92172 15.0424 8.17157 14.2968C7.42143 13.5512 7 12.54 7 11.4855C7 10.4311 7.42143 9.41984 8.17157 8.67424C8.92172 7.92864 9.93913 7.50977 11 7.50977C12.0609 7.50977 13.0783 7.92864 13.8284 8.67424C14.5786 9.41984 15 10.4311 15 11.4855V11.4855Z"
        stroke="#174A84"
        strokeWidth="2"
      />
    </svg>
  );
}
export function IconCompany() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_418_47082)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.849 11.5244C15.5236 11.1989 14.9959 11.1989 14.6705 11.5244C14.3451 11.8498 14.3451 12.3774 14.6705 12.7029L16.7831 14.8155L9.99937 14.8153C9.53913 14.8153 9.16602 15.1884 9.16602 15.6486C9.16601 16.1089 9.5391 16.482 9.99933 16.482L16.7838 16.4821L14.6705 18.5954C14.3451 18.9209 14.3451 19.4485 14.6705 19.7739C14.9959 20.0994 15.5236 20.0994 15.849 19.7739L19.3846 16.2384C19.7094 15.9135 19.71 15.3871 19.3862 15.0615M15.849 11.5244L19.3838 15.0592L15.849 11.5244Z"
          fill="#2F80ED"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.29986 0.277344H11.2184C11.5828 0.277344 11.9323 0.422112 12.19 0.679801C12.4477 0.93749 12.5924 1.28699 12.5924 1.65142V10.8332H11.2962V1.65142C11.2962 1.6412 11.2941 1.63109 11.2902 1.62165C11.2863 1.61222 11.2806 1.60364 11.2734 1.59642C11.2661 1.5892 11.2576 1.58347 11.2481 1.57956C11.2387 1.57565 11.2286 1.57364 11.2184 1.57364H2.29986C2.28964 1.57364 2.27953 1.57565 2.27009 1.57956C2.26065 1.58347 2.25208 1.5892 2.24486 1.59642C2.23764 1.60364 2.23191 1.61222 2.228 1.62165C2.22409 1.63109 2.22208 1.6412 2.22208 1.65142V18.4255H4.16652V16.481H5.83301V19.7218H0.925781V1.65142C0.925781 1.28699 1.07055 0.93749 1.32824 0.679801C1.58593 0.422112 1.93543 0.277344 2.29986 0.277344ZM18.4254 9.1665H19.7217V4.81501C19.7217 4.47121 19.5851 4.1415 19.342 3.89839C19.0989 3.65529 18.7692 3.51872 18.4254 3.51872H13.2402V4.81501H18.4254V9.1665ZM3.51855 3.51872H4.81485V4.81501H3.51855V3.51872ZM7.40762 3.51872H6.11133V4.81501H7.40762V3.51872ZM8.7041 3.51872H10.0004V4.81501H8.7041V3.51872ZM4.81485 6.75928H3.51855V8.05557H4.81485V6.75928ZM6.11133 6.75928H7.40762V8.05557H6.11133V6.75928ZM10.0004 6.75928H8.7041V8.05557H10.0004V6.75928ZM3.51855 9.99984H4.81485V11.2961H3.51855V9.99984ZM4.81485 13.2404H3.51855V14.5367H4.81485V13.2404ZM13.2402 6.75928H14.5365V8.05557H13.2402V6.75928ZM17.1293 6.75928H15.833V8.05557H17.1293V6.75928ZM6.11133 9.95345H7.40762V11.2497H6.11133V9.95345Z"
          fill="#2F80ED"
        />
      </g>
    </svg>
  );
}
export function DashboardExport() {
  return (
    <svg
      width="19"
      height="14"
      viewBox="0 0 19 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.86358 0C1.09262 0 1.31227 0.0884996 1.47422 0.24603C1.63618 0.403561 1.72716 0.617218 1.72716 0.84V13.16C1.72716 13.3828 1.63618 13.5964 1.47422 13.754C1.31227 13.9115 1.09262 14 0.86358 14C0.634544 14 0.414889 13.9115 0.252937 13.754C0.0909839 13.5964 4.82657e-09 13.3828 0 13.16V0.84C0 0.617218 0.0909839 0.403561 0.252937 0.24603C0.414889 0.0884996 0.634544 0 0.86358 0ZM3.45432 7C3.45432 6.77722 3.5453 6.56356 3.70726 6.40603C3.86921 6.2485 4.08886 6.16 4.3179 6.16H16.0511L12.9192 3.1136C12.7666 2.95436 12.6836 2.74375 12.6875 2.52613C12.6915 2.30852 12.7821 2.10089 12.9403 1.94698C13.0985 1.79308 13.312 1.70492 13.5357 1.70108C13.7595 1.69724 13.976 1.77802 14.1397 1.9264L18.742 6.40192C18.8165 6.47422 18.8774 6.55877 18.9216 6.65168C18.9955 6.80823 19.0179 6.98313 18.9857 7.15252C18.9536 7.3219 18.8684 7.4775 18.742 7.59808L14.1397 12.0736C14.0606 12.1561 13.9653 12.2223 13.8594 12.2682C13.7534 12.3141 13.6391 12.3388 13.5231 12.3408C13.4072 12.3428 13.292 12.3221 13.1845 12.2798C13.0769 12.2376 12.9792 12.1747 12.8972 12.0949C12.8152 12.0152 12.7506 11.9201 12.7072 11.8155C12.6637 11.711 12.6424 11.5989 12.6444 11.4861C12.6465 11.3733 12.6719 11.2621 12.7191 11.1591C12.7663 11.056 12.8343 10.9633 12.9192 10.8864L16.0511 7.84H4.3179C4.08886 7.84 3.86921 7.7515 3.70726 7.59397C3.5453 7.43644 3.45432 7.22278 3.45432 7Z"
        fill="#2F80ED"
      />
    </svg>
  );
}
export function Overridefail() {
  return (
    <svg
      width="25"
      height="23"
      viewBox="0 0 25 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8536 2.83333C9.7762 2.83333 8.09212 4.51741 8.09212 6.59483C8.09212 8.67224 9.7762 10.3563 11.8536 10.3563C13.931 10.3563 15.6151 8.67224 15.6151 6.59483C15.6151 4.51741 13.931 2.83333 11.8536 2.83333ZM5.75879 6.59483C5.75879 3.22875 8.48754 0.5 11.8536 0.5C15.2197 0.5 17.9484 3.22875 17.9484 6.59483C17.9484 9.96091 15.2197 12.6897 11.8536 12.6897C10.9274 12.6897 10.0494 12.483 9.26323 12.1134C7.14993 12.7806 3.18586 15.0123 2.58066 19.3074H10.3857C11.03 19.3074 11.5523 19.8297 11.5523 20.474C11.5523 21.1184 11.03 21.6407 10.3857 21.6407H2.50059C1.25561 21.6407 0.0709671 20.5978 0.245728 19.1674C0.832503 14.365 4.51322 11.6642 7.13222 10.4494C6.27375 9.39912 5.75879 8.05711 5.75879 6.59483ZM24.3253 15.325C24.7809 14.8693 24.7809 14.1307 24.3253 13.675C23.8697 13.2194 23.131 13.2194 22.6754 13.675L20.0003 16.3501L17.3253 13.675C16.8697 13.2194 16.131 13.2194 15.6754 13.675C15.2198 14.1307 15.2198 14.8693 15.6754 15.325L18.3504 18L15.6754 20.675C15.2198 21.1307 15.2198 21.8693 15.6754 22.325C16.131 22.7806 16.8697 22.7806 17.3253 22.325L20.0003 19.6499L22.6754 22.325C23.131 22.7806 23.8697 22.7806 24.3253 22.325C24.7809 21.8693 24.7809 21.1307 24.3253 20.675L21.6502 18L24.3253 15.325Z"
        fill="#DF2F2F"
      />
    </svg>
  );
}
export function OverridePass() {
  return (
    <svg
      width="26"
      height="23"
      viewBox="0 0 26 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8536 2.83333C9.7762 2.83333 8.09212 4.51741 8.09212 6.59483C8.09212 8.67224 9.7762 10.3563 11.8536 10.3563C13.931 10.3563 15.6151 8.67224 15.6151 6.59483C15.6151 4.51741 13.931 2.83333 11.8536 2.83333ZM5.75879 6.59483C5.75879 3.22875 8.48754 0.5 11.8536 0.5C15.2197 0.5 17.9484 3.22875 17.9484 6.59483C17.9484 9.96091 15.2197 12.6897 11.8536 12.6897C10.9274 12.6897 10.0494 12.483 9.26323 12.1134C7.14993 12.7806 3.18586 15.0123 2.58066 19.3074H8.91726C9.56159 19.3074 10.0839 19.8297 10.0839 20.474C10.0839 21.1184 9.56159 21.6407 8.91726 21.6407H2.50059C1.25561 21.6407 0.0709671 20.5978 0.245728 19.1674C0.832503 14.365 4.51322 11.6642 7.13222 10.4494C6.27375 9.39912 5.75879 8.05711 5.75879 6.59483ZM24.9123 13.0913C25.3681 13.5467 25.3685 14.2854 24.9131 14.7412L17.3257 22.3362C17.1069 22.5552 16.8101 22.6783 16.5006 22.6783C16.1911 22.6784 15.8942 22.5555 15.6754 22.3366L12.1754 18.8366C11.7198 18.381 11.7198 17.6423 12.1754 17.1867C12.631 16.7311 13.3697 16.7311 13.8253 17.1867L16.4999 19.8613L23.2624 13.0921C23.7178 12.6363 24.4564 12.6359 24.9123 13.0913Z"
        fill="#00B050"
      />
    </svg>
  );
}

export function Heart() {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="1024"
      height="1024"
      viewBox="0 0 1024 1024"
    >
      <path
        fill="#2f80ed"
        d="M512.056 967.445c-9.692 0-18.306-3.232-24.768-9.696l-400.591-401.667c0 0 0 0-1.077-1.077-114.147-114.147-114.147-299.367 0-413.514 114.147-113.070 300.443-113.070 414.591 0l11.846 11.846c6.461-6.461 12.923-12.923 12.923-12.923 113.070-111.993 299.366-111.993 413.512 1.077 113.071 113.071 114.146 298.29 2.157 412.437 0 1.077-1.075 1.077-1.075 2.154l-402.748 401.667c-6.461 6.464-15.075 9.696-24.768 9.696zM135.156 506.547l376.901 376.901 376.9-376.901c87.229-87.226 87.229-229.372 0-315.52-87.223-87.226-229.368-87.226-315.519 0-1.077 1.077-36.613 36.613-36.613 36.613-6.461 6.461-15.075 9.692-24.768 9.692s-18.306-3.231-24.768-9.692l-36.614-36.613c-87.225-87.226-229.371-87.226-315.519 0-41.997 41.997-65.689 97.994-65.689 158.298 0 59.227 22.614 115.224 65.689 157.222z"
      ></path>
    </svg>
  );
}

export function Layout() {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="1024"
      height="1024"
      viewBox="0 0 1024 1024"
    >
      <path
        fill="#2f80ed"
        d="M982.766 0h-941.532c-22.774 0-41.234 18.46-41.234 41.234v941.53c0 22.776 18.46 41.236 41.234 41.236h941.53c22.776 0 41.236-18.46 41.236-41.234v-941.532c0-22.774-18.46-41.234-41.234-41.234zM941.53 941.53h-859.060v-859.060h859.060v859.060z"
      ></path>
      <path
        fill="#2f80ed"
        d="M41.234 346.374h942.904v82.47h-942.904v-82.47z"
      ></path>
      <path
        fill="#2f80ed"
        d="M596.532 387.608h82.47v596.532h-82.47v-596.532z"
      ></path>
      <path
        fill="#2f80ed"
        d="M41.234 636.392h596.532v82.47h-596.532v-82.47z"
      ></path>
    </svg>
  );
}

export function ArrowBoldRight() {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="1024"
      height="1024"
      viewBox="0 0 1024 1024"
    >
      <path
        fill="#2f80ed"
        d="M315.372 0l-118.742 118.744 393.372 393.257-393.372 393.257 118.742 118.743 511.999-512-511.999-512z"
      ></path>
    </svg>
  );
}

export function ArrowBoldLeft() {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="1024"
      height="1024"
      viewBox="0 0 1024 1024"
    >
      <path
        fill="#2f80ed"
        d="M708.628 1024l118.742-118.744-393.372-393.257 393.372-393.257-118.742-118.743-511.999 512 511.999 512z"
      ></path>
    </svg>
  );
}

export function DoubleArrowLeft() {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="1024"
      height="1024"
      viewBox="0 0 1024 1024"
    >
      <path
        fill="#2f80ed"
        d="M540.639 179.068l-333.362 333.362 333.362 333.362c33.508 33.508 33.508 87.636 0 121.144s-87.636 33.508-121.144 0l-394.364-394.364c-33.508-33.508-33.508-87.636 0-121.144l394.364-394.364c33.508-33.508 87.636-33.508 121.144 0 32.649 33.508 33.508 88.495 0 122.003z"
      ></path>
      <path
        fill="#2f80ed"
        d="M998.868 179.068l-333.362 333.362 333.362 333.362c33.508 33.508 33.508 87.636 0 121.144s-87.636 33.508-121.144 0l-394.364-394.364c-33.508-33.508-33.508-87.636 0-121.144l394.364-394.364c33.508-33.508 87.636-33.508 121.144 0 32.649 33.508 33.508 88.495 0 122.003z"
      ></path>
    </svg>
  );
}

export function ExpandIcon() {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23 10.3496L20.7 10.3496L20.7 2.29961L12.65 2.29961L12.65 -0.000390102L23 -0.000391006L23 10.3496Z"
        fill="#174A84"
      />
      <path
        d="M10.3496 20.7L2.29961 20.7L2.29961 12.65L-0.000390102 12.65L-0.000391006 23L10.3496 23L10.3496 20.7Z"
        fill="#174A84"
      />
    </svg>
  );
}
export function CollapseIcon() {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 14.95H8.05V23H10.35V12.65H0V14.95ZM14.95 0H12.65V10.35H23V8.05H14.95V0Z"
        fill="#174A84"
      />
    </svg>
  );
}

export function Profile() {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 31.5C25.4557 31.5 31.5 25.4557 31.5 18C31.5 10.5443 25.4557 4.5 18 4.5C10.5443 4.5 4.5 10.5443 4.5 18C4.5 25.4557 10.5443 31.5 18 31.5ZM18 33C26.2845 33 33 26.2845 33 18C33 9.7155 26.2845 3 18 3C9.7155 3 3 9.7155 3 18C3 26.2845 9.7155 33 18 33Z"
        fill="#174A84"
      />
      <path
        d="M9 26.7223C9 25.9476 9.579 25.2928 10.35 25.2073C16.1363 24.5668 19.89 24.6246 25.6635 25.2216C25.9518 25.2519 26.2251 25.3654 26.4499 25.5485C26.6747 25.7315 26.8414 25.976 26.9295 26.2522C27.0176 26.5283 27.0234 26.8242 26.9462 27.1036C26.8689 27.383 26.712 27.6339 26.4945 27.8256C19.6808 33.7648 15.7868 33.6831 9.48 27.8316C9.1725 27.5466 9 27.1416 9 26.7231V26.7223Z"
        fill="#174A84"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.5863 25.9675C19.8585 25.375 16.1588 25.3195 10.4318 25.9532C10.2432 25.9752 10.0694 26.0659 9.94365 26.208C9.81786 26.3501 9.74891 26.5337 9.75 26.7235C9.75 26.938 9.83925 27.1412 9.99 27.2822C13.116 30.1817 15.4845 31.492 17.7998 31.5002C20.1233 31.5085 22.6193 30.2087 26.0018 27.2612C26.1092 27.1656 26.1866 27.0408 26.2244 26.902C26.2623 26.7632 26.259 26.6164 26.215 26.4794C26.171 26.3425 26.0881 26.2212 25.9765 26.1305C25.8649 26.0397 25.7293 25.9833 25.5863 25.9682V25.9675ZM10.2675 24.4622C16.1145 23.815 19.923 23.8735 25.7415 24.4757C26.1752 24.521 26.5863 24.6917 26.9245 24.967C27.2627 25.2424 27.5133 25.6103 27.6455 26.0259C27.7778 26.4414 27.7861 26.8865 27.6693 27.3066C27.5525 27.7268 27.3157 28.1038 26.988 28.3915C23.5568 31.3825 20.6993 33.0115 17.7953 33.0002C14.883 32.9897 12.1515 31.333 8.97075 28.3817C8.74302 28.1696 8.56147 27.9128 8.43746 27.6273C8.31345 27.3419 8.24963 27.0339 8.25 26.7227C8.24891 26.1635 8.45416 25.6236 8.82643 25.2064C9.1987 24.7891 9.71182 24.5239 10.2675 24.4615V24.4622Z"
        fill="#174A84"
      />
      <path
        d="M24 15C24 16.5913 23.3679 18.1174 22.2426 19.2426C21.1174 20.3679 19.5913 21 18 21C16.4087 21 14.8826 20.3679 13.7574 19.2426C12.6321 18.1174 12 16.5913 12 15C12 13.4087 12.6321 11.8826 13.7574 10.7574C14.8826 9.63214 16.4087 9 18 9C19.5913 9 21.1174 9.63214 22.2426 10.7574C23.3679 11.8826 24 13.4087 24 15Z"
        fill="#174A84"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 19.5C19.1935 19.5 20.3381 19.0259 21.182 18.182C22.0259 17.3381 22.5 16.1935 22.5 15C22.5 13.8065 22.0259 12.6619 21.182 11.818C20.3381 10.9741 19.1935 10.5 18 10.5C16.8065 10.5 15.6619 10.9741 14.818 11.818C13.9741 12.6619 13.5 13.8065 13.5 15C13.5 16.1935 13.9741 17.3381 14.818 18.182C15.6619 19.0259 16.8065 19.5 18 19.5ZM18 21C19.5913 21 21.1174 20.3679 22.2426 19.2426C23.3679 18.1174 24 16.5913 24 15C24 13.4087 23.3679 11.8826 22.2426 10.7574C21.1174 9.63214 19.5913 9 18 9C16.4087 9 14.8826 9.63214 13.7574 10.7574C12.6321 11.8826 12 13.4087 12 15C12 16.5913 12.6321 18.1174 13.7574 19.2426C14.8826 20.3679 16.4087 21 18 21Z"
        fill="#174A84"
      />
    </svg>
  );
}

export function vesselWarning() {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="17" cy="17" r="17" fill="#DF2F2F" />
      <path
        d="M6.12575 23.2609L16.2057 5.4608C16.7928 4.42401 18.2961 4.45263 18.8434 5.51101L28.0468 23.3111C28.563 24.3095 27.8384 25.5 26.7144 25.5H7.43099C6.28185 25.5 5.55949 24.2608 6.12575 23.2609Z"
        fill="#DF2F2F"
        stroke="white"
      />
      <path
        d="M17.5 11C17.1817 11 16.8765 11.1233 16.6515 11.3429C16.4264 11.5625 16.3 11.8602 16.3 12.1707V16.8537C16.3 17.1642 16.4264 17.4619 16.6515 17.6815C16.8765 17.901 17.1817 18.0244 17.5 18.0244C17.8183 18.0244 18.1235 17.901 18.3485 17.6815C18.5736 17.4619 18.7 17.1642 18.7 16.8537V12.1707C18.7 11.8602 18.5736 11.5625 18.3485 11.3429C18.1235 11.1233 17.8183 11 17.5 11ZM17.5 23C17.8978 23 18.2794 22.8458 18.5607 22.5714C18.842 22.2969 19 21.9247 19 21.5366C19 21.1485 18.842 20.7762 18.5607 20.5018C18.2794 20.2274 17.8978 20.0732 17.5 20.0732C17.1022 20.0732 16.7206 20.2274 16.4393 20.5018C16.158 20.7762 16 21.1485 16 21.5366C16 21.9247 16.158 22.2969 16.4393 22.5714C16.7206 22.8458 17.1022 23 17.5 23Z"
        fill="white"
      />
    </svg>
  );
}
export function PortWarning() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="17" cy="17" r="17" fill="#DF2F2F" />
      <path
        d="M6.12575 23.2609L16.2057 5.4608C16.7928 4.42401 18.2961 4.45263 18.8434 5.51101L28.0468 23.3111C28.563 24.3095 27.8384 25.5 26.7144 25.5H7.43099C6.28185 25.5 5.55949 24.2608 6.12575 23.2609Z"
        fill="#DF2F2F"
        stroke="white"
      />
      <path
        d="M17.5 11C17.1817 11 16.8765 11.1233 16.6515 11.3429C16.4264 11.5625 16.3 11.8602 16.3 12.1707V16.8537C16.3 17.1642 16.4264 17.4619 16.6515 17.6815C16.8765 17.901 17.1817 18.0244 17.5 18.0244C17.8183 18.0244 18.1235 17.901 18.3485 17.6815C18.5736 17.4619 18.7 17.1642 18.7 16.8537V12.1707C18.7 11.8602 18.5736 11.5625 18.3485 11.3429C18.1235 11.1233 17.8183 11 17.5 11ZM17.5 23C17.8978 23 18.2794 22.8458 18.5607 22.5714C18.842 22.2969 19 21.9247 19 21.5366C19 21.1485 18.842 20.7762 18.5607 20.5018C18.2794 20.2274 17.8978 20.0732 17.5 20.0732C17.1022 20.0732 16.7206 20.2274 16.4393 20.5018C16.158 20.7762 16 21.1485 16 21.5366C16 21.9247 16.158 22.2969 16.4393 22.5714C16.7206 22.8458 17.1022 23 17.5 23Z"
        fill="white"
      />
    </svg>
  );
}
export function LiveTracking() {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      fill="#000000"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <g transform="translate(0 -1028.4)">
          {' '}
          <path d="m8 1030.4 8 1v19l-8-1z" fill="#ecf0f1"></path>{' '}
          <path d="m2 1031.4 6-1v19l-6 1z" fill="#bdc3c7"></path>{' '}
          <path d="m16 1031.4 6-1v19l-6 1z" fill="#bdc3c7"></path>{' '}
          <path d="m3 1032.4 5-1v17l-5 1z" fill="#27ae60"></path>{' '}
          <path d="m8 1031.4 8 1v17l-8-1z" fill="#2ecc71"></path>{' '}
          <path
            d="m13 1c-1.657 0-3 1.3432-3 3s1.343 3 3 3 3-1.3432 3-3-1.343-3-3-3zm0 2c0.552 0 1 0.4477 1 1s-0.448 1-1 1-1-0.4477-1-1 0.448-1 1-1z"
            transform="translate(0 1028.4)"
            fill="#c0392b"
          ></path>{' '}
          <path d="m21 1048.4-5 1v-17l5-1z" fill="#27ae60"></path>{' '}
          <path
            d="m5.6875 1031.8-2.3125 0.5 4.625 4.9v-2.9l-2.3125-2.5z"
            fill="#f39c12"
          ></path>{' '}
          <path d="m21 1046.4-5 1v-6l5-3z" fill="#f39c12"></path>{' '}
          <path d="m21 1048.4-5 1v-6l5-3z" fill="#2980b9"></path>{' '}
          <path d="m8 1042.4 8-1v6l-8-1z" fill="#f1c40f"></path>{' '}
          <path d="m8 1044.4 8-1v6l-8-1z" fill="#3498db"></path>{' '}
          <path d="m3 1045.4 5-3v4l-5 1z" fill="#f39c12"></path>{' '}
          <path d="m3 1047.4 5-3v4l-5 1z" fill="#2980b9"></path>{' '}
          <path
            d="m8 8.8008v-2.8985l4 8.6597h-1.469z"
            transform="translate(0 1028.4)"
            fill="#f1c40f"
          ></path>{' '}
          <path
            d="m13 1028.4c-2.209 0-4 1.8-4 4 0 0.7 0.1908 1.3 0.5156 1.9 0.0539 0.1 0.1105 0.2 0.1719 0.3l3.3125 5.8 3.312-5.8c0.051-0.1 0.095-0.2 0.141-0.2l0.031-0.1c0.325-0.6 0.516-1.2 0.516-1.9 0-2.2-1.791-4-4-4zm0 2c1.105 0 2 0.9 2 2s-0.895 2-2 2-2-0.9-2-2 0.895-2 2-2z"
            fill="#e74c3c"
          ></path>{' '}
        </g>{' '}
      </g>
    </svg>
  );
}
export function PinIcon(color?: string) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 101 159"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.798 1.931C10.528 10.01 -4.071 36.109 2.521 61.418C5.031 71.057 11.61 86.888 20.297 104.198C28.6 120.741 50.024 159.003 50.98 158.996C51.6 158.992 70.449 125.895 78.315 111C86.301 95.876 95.598 74.416 98.497 64.413C103.731 46.353 100.371 30.112 88.549 16.322C83.597 10.546 74.047 4.404 66.295 2.009C57.811 -0.611 43.86 -0.647 35.798 1.931ZM67.246 14.734C75.719 18.699 82.276 25.252 86.326 33.799C89.205 39.877 89.498 41.383 89.482 50C89.466 58.651 89.176 60.094 86.233 66.142C82.082 74.672 73.358 82.974 65.426 85.942C45.542 93.381 25.151 85.213 15.693 66.021C12.78 60.109 12.5 58.708 12.5 50.021C12.5 41.4 12.8 39.867 15.674 33.799C22.734 18.897 36.17 10.705 52.545 11.319C59.057 11.563 61.859 12.214 67.246 14.734ZM43.589 24.077C42.165 25.769 41 28.266 41 29.626C41 32.77 43.461 37.579 45.463 38.347C46.745 38.839 47 41.275 47 53.036V67.135L44.75 66.455C42.213 65.689 37 61.127 37 59.673C37 59.149 37.787 58.145 38.748 57.442C39.71 56.739 40.199 55.865 39.834 55.501C38.881 54.548 25.133 52.533 24.424 53.243C24.096 53.57 24.382 57.267 25.058 61.459L26.287 69.079L28.655 66.854L31.023 64.63L34.261 67.703C43.959 76.905 57.839 77.051 66.582 68.042L70.45 64.057L73.1 66.596L75.75 69.135L76.944 60.97C77.601 56.479 77.979 52.646 77.785 52.452C77.381 52.047 62.711 54.08 62.089 54.627C61.864 54.825 62.531 55.93 63.573 57.081C65.451 59.156 65.431 59.208 61.272 63.087C54.353 69.541 54 69.072 54 53.435V39.871L56.926 37.408C60.655 34.271 61.623 30.105 59.553 26.103C57.579 22.285 55.212 21 50.155 21C46.942 21 45.681 21.591 43.589 24.077ZM54.171 26.655C56.56 28.817 56.489 31.248 53.97 33.527C51.001 36.214 46.623 34.533 46.164 30.531C45.611 25.699 50.5 23.333 54.171 26.655Z"
        fill={color ?? '#AC0003'}
      />
    </svg>
  );
}
export function liveFilter() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 4.5C3 4.10218 3.15804 3.72064 3.43934 3.43934C3.72064 3.15804 4.10218 3 4.5 3H15.5C15.8978 3 16.2794 3.15804 16.5607 3.43934C16.842 3.72064 17 4.10218 17 4.5C17 4.89782 16.842 5.27936 16.5607 5.56066C16.2794 5.84196 15.8978 6 15.5 6H4.5C4.10218 6 3.72064 5.84196 3.43934 5.56066C3.15804 5.27936 3 4.89782 3 4.5Z"
        fill="#000000"
      />
      <path
        d="M6 9.5C6 9.10218 6.15804 8.72064 6.43934 8.43934C6.72064 8.15804 7.10218 8 7.5 8H12.5C12.8978 8 13.2794 8.15804 13.5607 8.43934C13.842 8.72064 14 9.10218 14 9.5C14 9.89782 13.842 10.2794 13.5607 10.5607C13.2794 10.842 12.8978 11 12.5 11H7.5C7.10218 11 6.72064 10.842 6.43934 10.5607C6.15804 10.2794 6 9.89782 6 9.5Z"
        fill="#000000"
      />
      <path
        d="M8 14.5C8 14.1022 8.15804 13.7206 8.43934 13.4393C8.72064 13.158 9.10218 13 9.5 13H10.5C10.8978 13 11.2794 13.158 11.5607 13.4393C11.842 13.7206 12 14.1022 12 14.5C12 14.8978 11.842 15.2794 11.5607 15.5607C11.2794 15.842 10.8978 16 10.5 16H9.5C9.10218 16 8.72064 15.842 8.43934 15.5607C8.15804 15.2794 8 14.8978 8 14.5Z"
        fill="#000000"
      />
    </svg>
  );
}

export default {
  liveFilter,
  Search,
  Bell,
  Slider,
  MarsLogo,
  Confirmation,
  Plus,
  GridExport,
  SuccessIcon,
  NoListIcon,
  AngleLeft,
  AddIcon,
  RemoveIcon,
  Calendar,
  ChevronDown,
  Trash,
  Image,
  Attach,
  Square,
  Star,
  BookMeck,
  Mail,
  Send,
  CircleTick,
  CircleCross,
  PlusIcon,
  MinusIcon,
  ChevronUp,
  download,
  mailIcon,
  mailIconSuccess,
  mailIconDanger,
  Close,
  IconExpand,
  CopyIcon,
  IconCross,
  IconAlert,
  IconFile,
  Menu,
  IconSearch16,
  IconAttach12,
  circleCrossDanger,
  circleTickDanger,
  IconBuildings,
  IconShip,
  IconSend,
  Iconinfo,
  IconUpload,
  IconPencil,
  IconDelete,
  IconEyeOpen,
  IconEyeClose,
  filetypeIcon,
  ArchiveIcon,
  ErrorIcon,
  IconEdit,
  downArrow,
  toastCloseIcon,
  AttachBlueIcon,
  ReplayIcon,
  IconPDF,
  IconSettings,
  IconCompany,
  DashboardExport,
  Overridefail,
  OverridePass,
  Heart,
  Layout,
  ArrowBoldRight,
  ArrowBoldLeft,
  DoubleArrowLeft,
  CollapseIcon,
  ExpandIcon,
  Profile,
  vesselWarning,
  FilledStar,
  PortWarning,
  LiveTracking,
  PinIcon,
};
